import React from "react";
import DataTable from "./../../partials/table/DataTables.js";
import { Link } from "react-router-dom";
import conf from "./../../../config.js";
import SelectJs from "./../../partials/Select.js";
import axios from "axios";
import tokenApi from "../../auth/Helpers";
import { Button, Modal } from "react-bootstrap";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import DatePicker from "react-datepicker";
import SweetAlert from "sweetalert2-react";
import Select from "react-select";
import { Tab, Tabs } from "react-bootstrap";
import { useChecklist } from "react-checklist";
import swal from "sweetalert2";

import "react-datepicker/dist/react-datepicker.css";
import Skeleton from "react-loading-skeleton";
import {
  UserEditSkeleton,
  UserDetailSkeleton,
  UserPrintSkeleton,
  UserButtonLoading,
} from "../../partials/loadings/ComponentLoading.js";
import ModalDropZoneImage from "../../partials/ModalDropZoneImage";
import DeleteProgressModal from "../../partials/DeleteProgressModal";
import ExcelImportWizard from "../../partials/ExcelImportWizard";


// select style
const selectStyles = {
  control: (styles) => ({
    ...styles,
    borderRadius: "100px",
    minWidth: "15rem",
  }),
};

export default class Lainnya extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // url api
      url_table: `${conf.uri_backend}api/v1/user/table/LA/`,
      url_count_table: `${conf.uri_backend}api/v1/user/count_table/LA`,
      url_create: `${conf.uri_backend}api/v1/user/create/LA`,
      url_get_user: `${conf.uri_backend}api/v1/user/edit/LA/`,
      url_update: `${conf.uri_backend}api/v1/user/update/LA`,
      url_detail: `${conf.uri_backend}api/v1/user/edit/LA/`,
      url_token_user: `${conf.uri_backend}api/v1/user/update_token/LA`,
      url_generate_all_token: `${conf.uri_backend}api/v1/user/generate-all-token/LA`,
      url_table_token: `${conf.uri_backend}api/v1/user/table_token/LA`,
      url_print_token: `${conf.uri_backend}api/v1/user/generete_token/LA`,
      url_export_data: `${conf.uri_backend}api/v1/user/export/LA/`,
      url_import_data: `${conf.uri_backend}api/v1/user/import/LA`,
      url_save_import_data: `${conf.uri_backend}api/v1/user/import_save/LA/`,
      url_delete: `${conf.uri_backend}api/v1/user/LA/`,
      url_delete_m: `${conf.uri_backend}api/v1/user/user_destroy/LA`,
      url_send_mail: `${conf.uri_backend}api/v1/user/send_mail_activation/LA`,
      url_send_wa: `${conf.uri_backend}api/v1/user/send_wa_activation/LA`,
      url_generate_activation: `${conf.uri_backend}api/v1/user/generate_activation_codes/LA`,

      // modal
      modal_tambah: false,
      modal_detail: false,
      modal_cetak: false,
      modal_import: false,
      modal_preview_import: false,
      modal_image: false,
      modal_generate_activation: false,


      // var data
      id_generate: "",
      nik: "",
      nama: "",
      username: "",
      email: "",
      password: "",
      jenis_kelamin: "",
      tanggal_lahir: "",
      no_telepon: "",
      startDate: new Date(),
      import_file: "",

      // gender array
      jenis_kelamin_text: ["Perempuan", "Laki - laki"],

      // for data
      data_print: [],
      data_detail: [],
      data_preview: [],

      // alert
      show_alert: false,
      title_alert: "",
      message_alert: "",
      icon_alert: "",

      // session var
      institusi_id_select: "",
      jenjang_id_select: "",
      npsn_id_select: "",
      data_session: [],

      mode_show: 10,
      query: "",
      simpleLoading: false,
      totalUser: "",

      queryToken: "",
      mode_show_token: 10,
      searchToken: "",

      isChecked: false,
      check_item: false,
      checkAll: false,
      loading_check: false,
      selectStatus: "",
      loading_generate_token: false,

      // Generate Activation Code Variables
      activation_tahun_ajaran: "",
      activation_prefix: "",
      activation_jumlah_token: "",
      activation_token_sama: false,
      activation_mode: "auto", // "auto" = jumlah saja, "manual" = kode & token diisi sendiri
      activation_manual_list: [{ kode_pendaftaran: "", token: "" }],
      loading_generate_activation: false,
      data_tahun_ajaran: [],
      tahunSekarang: new Date().getFullYear(),

      // Validation URLs
      url_check_username: `${conf.uri_backend}api/v1/user/check-username/LA`,
      url_check_email: `${conf.uri_backend}api/v1/user/check-email/LA`,
      url_check_nik: `${conf.uri_backend}api/v1/user/check-nik/LA`,

      // Real-time validation state
      usernameAvailable: null,
      usernameRecommendations: [],
      emailAvailable: null,
      emailMessage: "",
      nikAvailable: null,
      nikMessage: "",
      checkingUsername: false,
      checkingEmail: false,
      checkingNik: false,
      usernameCheckTimeout: null,
      emailCheckTimeout: null,
      nikCheckTimeout: null,

      // Password UI state
      showPassword: false,
      passwordStrength: "",
      passwordStrengthText: "",

      // User tracking for edit
      userStatus: "",
      user_id_edit: null,
      loading_delete: false,

      // Delete Progress Modal state
      modal_delete_progress: false,
      delete_user_id: null,
      delete_user_name: "",
      delete_steps: [],
      delete_current_step: 0,
      delete_error: null,
      is_deleting: false,
      delete_complete: false,
    };

    // Edit Function
    this.update = this.update.bind(this);
    this.showModalEdit = this.showModalEdit.bind(this);
    this.hideModalEdit = this.hideModalEdit.bind(this);

    // Create Function
    this.showModalTambah = this.showModalTambah.bind(this);
    this.hideModalTambah = this.hideModalTambah.bind(this);
    this.create = this.create.bind(this);

    // Delete Function
    this.delete = this.delete.bind(this);

    // Bind data
    this.nama = this.nama.bind(this);
    this.username = this.username.bind(this);
    this.email = this.email.bind(this);
    this.password = this.password.bind(this);
    this.nik = this.nik.bind(this);
    this.jenis_kelamin = this.jenis_kelamin.bind(this);
    this.tanggal_lahir = this.tanggal_lahir.bind(this);
    this.no_telepon = this.no_telepon.bind(this);

    // Token Function
    this.generate_token = this.generate_token.bind(this);
    this.generateAllToken = this.generateAllToken.bind(this);
    this.id_generate = this.id_generate.bind(this);

    // Detail Function
    this.showModalDetail = this.showModalDetail.bind(this);
    this.hideModalDetail = this.hideModalDetail.bind(this);

    // Cetak Function
    this.showModalCetak = this.showModalCetak.bind(this);
    this.hideModalCetak = this.hideModalCetak.bind(this);
    this.printToken = this.printToken.bind(this);
    this.showTableToken = this.showTableToken.bind(this);

    // Reset Search Function
    this.resetSearch = this.resetSearch.bind(this);
    this.searchText = this.searchText.bind(this);

    // Export Function
    this.export = this.export.bind(this);

    // Import Function
    this.showModalImport = this.showModalImport.bind(this);
    this.hideModalImport = this.hideModalImport.bind(this);
    this.import_file = this.import_file.bind(this);
    this.import = this.import.bind(this);

    // Preview Import Function
    this.showModalPrevImport = this.showModalPrevImport.bind(this);
    this.hideModalPrevImport = this.hideModalPrevImport.bind(this);
    this.simpanImport = this.simpanImport.bind(this);
    this.showMode = this.showMode.bind(this);
    this.showModeToken = this.showModeToken.bind(this);

    this.pilihSemua = this.pilihSemua.bind(this);
    this.showCount = this.showCount.bind(this);

    this.checkAll = this.checkAll.bind(this);
    this.unCheckAll = this.unCheckAll.bind(this);
    this.deleteMulti = this.deleteMulti.bind(this);
    this.sendMailActivation = this.sendMailActivation.bind(this);
    this.sendWAActivation = this.sendWAActivation.bind(this);

    // Generate Activation Code Functions
    this.showModalGenerateActivation = this.showModalGenerateActivation.bind(this);
    this.hideModalGenerateActivation = this.hideModalGenerateActivation.bind(this);
    this.generateActivationCodes = this.generateActivationCodes.bind(this);
    this.activationTahunAjaran = this.activationTahunAjaran.bind(this);
    this.activationPrefix = this.activationPrefix.bind(this);
    this.activationJumlahToken = this.activationJumlahToken.bind(this);
    this.activationTokenSama = this.activationTokenSama.bind(this);
    this.activationSetMode = this.activationSetMode.bind(this);
    this.activationManualChange = this.activationManualChange.bind(this);
    this.activationAddManualRow = this.activationAddManualRow.bind(this);
    this.activationRemoveManualRow = this.activationRemoveManualRow.bind(this);
    this.getTahunAjaranNow = this.getTahunAjaranNow.bind(this);

    // Dropzone image
    this.showModalDropzoneImage = this.showModalDropzoneImage.bind(this);
    this.hideModalDropzoneImage = this.hideModalDropzoneImage.bind(this);
  }

  componentDidMount() {
    // get session user
    if (localStorage.getItem("token") !== null) {
      axios
        .post(`${conf.uri_backend}api/v1/auth/sso/user`, {
          token: localStorage.getItem("token"),
        })
        .then((res) => {
          this.setState({ data_session: res.data }, function () {
            axios
              .get(
                `${conf.uri_backend}api/v1/select-institusi/` +
                this.state.data_session.access_to,
                { headers: { Authorization: tokenApi } }
              )
              .then((res) => {
                this.setState(
                  {
                    institusi_id_select: res.data.id,
                    jenjang_id_select: res.data.m_struktur_jenjang_id,
                    npsn_id_select: res.data.npsn,
                  },
                  function () {
                    this.dt.fetchEntities(
                      `&paginate=${this.state.mode_show}&query=${this.state.query}`
                    );
                    this.showCount();
                  }
                );
              });
          });
        });
    }
    this.getTahunAjaranNow();
  }

  getTahunAjaranNow() {
    var ta = [];
    var u = this.state.tahunSekarang + 1;
    var tahun_sekarang = this.state.tahunSekarang + 1;

    for (var i = tahun_sekarang; i >= 2005; i--) {
      u = u - 1;
      ta.push({ value: u + " / " + i, label: u + " / " + i });
    }
    this.setState({ data_tahun_ajaran: ta });
  }

  showCount() {
    axios
      .get(
        this.state.url_count_table +
        "?institusi=" +
        this.state.institusi_id_select,
        { headers: { Authorization: tokenApi } }
      )
      .then((res) => {
        this.setState({ totalUser: res.data });
      });
  }

  showMode(num) {
    this.setState({ mode_show: num }, function () {
      this.dt.resetPage(
        `&paginate=${this.state.mode_show}&query=${this.state.query}`
      );
      this.dt.loading();
    });
  }

  showModeToken(num) {
    this.setState({ mode_show_token: num }, function () {
      this.dtt.resetPage(
        `&paginate=${this.state.mode_show_token}&search=${this.state.searchToken}`
      );
      this.dtt.loading();
      this.setState({ loading_saveprint: false });
    });
  }

  nama(e) {
    this.setState({ nama: e.target.value });
  }

  username(e) {
    this.setState({ username: e.target.value });
  }
  email(e) {
    this.setState({ email: e.target.value });
  }
  password(e) {
    this.setState({ password: e.target.value });
  }

  nik(e) {
    this.setState({ nik: e.target.value });
  }

  jenis_kelamin(e) {
    this.setState({ jenis_kelamin: e.target.value });
  }

  tanggal_lahir(e) {
    this.setState({
      tanggal_lahir: e.target.value,
      startDate: e.target.value,
    });
  }

  no_telepon(e) {
    this.setState({ no_telepon: e.target.value });
  }

  id_generate(e) {
    this.setState({ id_generate: e.target.value });
  }

  import_file(e) {
    this.setState({ import_file: e.target.files[0] });
  }

  // Real-time username validation with debounce
  checkUsernameAvailability(username) {
    if (this.state.usernameCheckTimeout) {
      clearTimeout(this.state.usernameCheckTimeout);
    }

    if (!username || username.length < 3) {
      this.setState({
        usernameAvailable: null,
        usernameRecommendations: [],
        checkingUsername: false,
      });
      return;
    }

    const timeout = setTimeout(() => {
      this.setState({ checkingUsername: true });

      axios
        .get(this.state.url_check_username, {
          params: {
            username: username,
            exclude_id: this.state.user_id_edit,
          },
          headers: { Authorization: tokenApi },
        })
        .then((res) => {
          this.setState({
            usernameAvailable: res.data.available,
            usernameRecommendations: res.data.recommendations || [],
            checkingUsername: false,
          });
        })
        .catch((err) => {
          console.error("Error checking username:", err);
          this.setState({
            usernameAvailable: null,
            usernameRecommendations: [],
            checkingUsername: false,
          });
        });
    }, 500);

    this.setState({ usernameCheckTimeout: timeout });
  }

  // Real-time email validation with debounce
  checkEmailAvailability(email) {
    if (this.state.emailCheckTimeout) {
      clearTimeout(this.state.emailCheckTimeout);
    }

    if (!email || email.length < 5) {
      this.setState({
        emailAvailable: null,
        emailMessage: "",
        checkingEmail: false,
      });
      return;
    }

    const timeout = setTimeout(() => {
      this.setState({ checkingEmail: true });

      axios
        .get(this.state.url_check_email, {
          params: {
            email: email,
            exclude_id: this.state.user_id_edit,
          },
          headers: { Authorization: tokenApi },
        })
        .then((res) => {
          this.setState({
            emailAvailable: res.data.available,
            emailMessage: res.data.message || "",
            checkingEmail: false,
          });
        })
        .catch((err) => {
          console.error("Error checking email:", err);
          this.setState({
            emailAvailable: null,
            emailMessage: "",
            checkingEmail: false,
          });
        });
    }, 500);

    this.setState({ emailCheckTimeout: timeout });
  }

  // Real-time NIK validation with debounce
  checkNikAvailability(nik) {
    if (this.state.nikCheckTimeout) {
      clearTimeout(this.state.nikCheckTimeout);
    }

    if (!nik || nik.length < 3) {
      this.setState({
        nikAvailable: null,
        nikMessage: "",
        checkingNik: false,
      });
      return;
    }

    const timeout = setTimeout(() => {
      this.setState({ checkingNik: true });

      axios
        .get(this.state.url_check_nik, {
          params: {
            nik: nik,
            exclude_id: this.state.user_id_edit,
          },
          headers: { Authorization: tokenApi },
        })
        .then((res) => {
          this.setState({
            nikAvailable: res.data.available,
            nikMessage: res.data.message || "",
            checkingNik: false,
          });
        })
        .catch((err) => {
          console.error("Error checking NIK:", err);
          this.setState({
            nikAvailable: null,
            nikMessage: "",
            checkingNik: false,
          });
        });
    }, 500);

    this.setState({ nikCheckTimeout: timeout });
  }

  // Toggle password visibility
  togglePasswordVisibility = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  // Check password strength
  checkPasswordStrength(password) {
    if (!password) {
      this.setState({ passwordStrength: "", passwordStrengthText: "" });
      return;
    }

    let strength = 0;
    if (password.length >= 8) strength++;
    if (/[a-z]/.test(password)) strength++;
    if (/[A-Z]/.test(password)) strength++;
    if (/[0-9]/.test(password)) strength++;
    if (/[^a-zA-Z0-9]/.test(password)) strength++;

    let strengthClass = "";
    let strengthText = "";

    if (strength <= 2) {
      strengthClass = "weak";
      strengthText = "Lemah";
    } else if (strength <= 3) {
      strengthClass = "medium";
      strengthText = "Sedang";
    } else {
      strengthClass = "strong";
      strengthText = "Kuat";
    }

    this.setState({
      passwordStrength: strengthClass,
      passwordStrengthText: strengthText,
    });
  }

  // Edit Funtion
  showModalEdit(id) {
    this.setState({ loading_edit: true, modal_edit: true });
    axios
      .get(this.state.url_get_user + id, {
        headers: { Authorization: tokenApi },
      })
      .then((res) => {
        if (res.data.status == true) {
          var data = res.data.data;
          this.setState({
            id_edit: data.id,
            user_id_edit: data.user_id,
            nik: data.kode_pendaftaran,
            nama: data.nama,
            username: data.username,
            email: data.email,
            password: "",
            jenis_kelamin: data.jenis_kelamin,
            tanggal_lahir: data.tanggal_lahir,
            no_telepon: data.no_handphone,
            userStatus: data.status || "Pending",
            loading_edit: false,
            // Reset validation states
            usernameAvailable: null,
            emailAvailable: null,
            nikAvailable: null,
          });
        }
      });
  }

  hideModalEdit() {
    this.setState({
      modal_edit: false,
      nama: "",
      nik: "",
      jenis_kelamin: "",
      tanggal_lahir: "",
      no_telepon: "",
    });
  }

  alertMessage(e) {
    let message = null;

    switch (e.status) {
      case 422:
        message = e.data.messages[0];
        break;
      case 500:
        message =
          "Ada yang Salah, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 404:
        message = "Url Not Found, Coba Hubungi Admin 😊";
        break;
      case 401:
        message =
          "Nauthorized, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 400:
        message =
          "Koneksi Buruk, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 408:
        message =
          "Request Timeout, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 429:
        message =
          "Too Many Request, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 405:
        message =
          "Method Tidak Diperbolehkan, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
    }

    this.setState({
      show_alert: true,
      title_alert: "Gagal",
      icon_alert: "error",
      message_alert: message,
      simpleLoading: false,
    });
  }

  update(event) {
    event.preventDefault();
    this.setState({ simpleLoading: true });

    if (
      this.state.nama === "" ||
      this.state.nik === "" ||
      this.state.jenis_kelamin === "" ||
      this.state.tanggal_lahir === ""
    ) {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "error",
        message_alert: "Isi form dengan benar",
        simpleLoading: false,
      });
    } else {
      axios
        .post(
          this.state.url_update,
          {
            id: this.state.id_edit,
            nama: this.state.nama,
            username: this.state.username,
            email: this.state.email,
            password: this.state.password,
            nama: this.state.nama,
            kode_pendaftaran: this.state.nik,
            no_handphone: this.state.no_telepon,
            jenis_kelamin: this.state.jenis_kelamin,
            tanggal_lahir: this.state.tanggal_lahir,
            // updated_at          : new Date(),
            updated_by: this.state.institusi_id_select,
            type: "lainnya",
          },
          { headers: { Authorization: tokenApi } }
        )
        .then((res) => {
          this.setState({
            show_alert: true,
            title_alert: "Berhasil",
            icon_alert: "success",
            message_alert: res.data.messages[0],
            simpleLoading: false,
          });
          this.hideModalEdit();
          this.dt.fetchEntities(
            `&paginate=${this.state.mode_show}&query=${this.state.query}`
          );
        })
        .catch((err) => {
          this.alertMessage(err.response);
        });
    }
  }

  // Create Function
  showModalTambah() {
    this.setState({ modal_tambah: true });
  }

  hideModalTambah() {
    this.setState({
      modal_tambah: false,
      nama: "",
      nik: "",
      jenis_kelamin: "",
      tanggal_lahir: "",
      no_telepon: "",
    });
  }

  create(event) {
    event.preventDefault();

    this.setState({ simpleLoading: true });

    axios
      .post(
        this.state.url_create,
        {
          username: this.state.username,
          email: this.state.email,
          password: this.state.password,
          nama: this.state.nama,
          nama: this.state.nama,
          kode_pendaftaran: this.state.nik,
          no_handphone: this.state.no_telepon,
          jenis_kelamin: this.state.jenis_kelamin,
          tanggal_lahir: this.state.tanggal_lahir,
          user_institusi_id: this.state.institusi_id_select,
          created_at: new Date(),
          created_by: this.state.institusi_id_select,
          type: "lainnya",
        },
        { headers: { Authorization: tokenApi } }
      )
      .then((res) => {
        this.setState({
          show_alert: true,
          title_alert: "Berhasil",
          icon_alert: "success",
          message_alert: res.data.messages[0],
          simpleLoading: false,
        });
        this.dt.fetchEntities(
          `&paginate=${this.state.mode_show}&query=${this.state.query}`
        );
        this.dt.loadingCreate();
        this.hideModalTambah();
      })
      .catch((err) => {
        this.alertMessage(err.response);
      });
  }

  // Delete Lainnya - Premium Modal Version
  delete(data, userName = "User Lainnya") {
    this.setState({
      modal_delete_progress: true,
      delete_type: 'single',
      delete_user_id: data,
      delete_user_name: userName,
      delete_steps: [
        { name: "Menghapus akun SSO staff", status: "pending" },
        { name: "Menghapus penugasan lainnya", status: "pending" },
        { name: "Menghapus data user lainnya", status: "pending" },
      ],
      delete_current_step: 0,
      delete_error: null,
      is_deleting: false,
      delete_complete: false,
    });
  }

  hideDeleteProgressModal = () => {
    this.setState({ modal_delete_progress: false });
    // Refresh table if delete was successful
    if (this.state.delete_complete) {
      this.dt.fetchEntities(
        `&paginate=${this.state.mode_show}&query=${this.state.query}`
      );
      this.showCount();
    }
  };

  executeDelete = () => {
    if (this.state.delete_type === 'multiple') {
      this.setState({ is_deleting: true });
      this.executeBulkDeleteNextBatch(0);
      return;
    }

    this.setState({ is_deleting: true });

    // Simulate progress through steps while actual delete runs
    const simulateProgress = (stepIndex) => {
      if (stepIndex >= this.state.delete_steps.length) return;

      const newSteps = [...this.state.delete_steps];
      newSteps[stepIndex].status = "running";
      this.setState({ delete_steps: newSteps, delete_current_step: stepIndex });
    };

    // Start simulating progress
    let currentStep = 0;
    simulateProgress(currentStep);

    const progressInterval = setInterval(() => {
      currentStep++;
      if (currentStep < this.state.delete_steps.length) {
        // Mark previous as success, current as running
        const newSteps = [...this.state.delete_steps];
        newSteps[currentStep - 1].status = "success";
        newSteps[currentStep].status = "running";
        this.setState({ delete_steps: newSteps, delete_current_step: currentStep });
      }
    }, 400);

    // Execute actual delete
    axios
      .delete(this.state.url_delete + this.state.delete_user_id, {
        headers: { Authorization: tokenApi },
      })
      .then((res) => {
        clearInterval(progressInterval);

        // Mark all steps as success
        const newSteps = this.state.delete_steps.map((step) => ({
          ...step,
          status: "success",
        }));

        this.setState({
          delete_steps: newSteps,
          is_deleting: false,
          delete_complete: true,
        });
      })
      .catch((err) => {
        clearInterval(progressInterval);

        // Determine which step failed
        let errorMessage = "Terjadi kesalahan, silakan coba lagi";

        if (err.response && err.response.data) {
          const errorData = err.response.data;
          if (errorData.message) {
            errorMessage = errorData.message;
          } else if (errorData.messages) {
            errorMessage = Array.isArray(errorData.messages)
              ? errorData.messages[0]
              : errorData.messages;
          }
        } else if (!err.response) {
          errorMessage = "Periksa koneksi internet anda";
        }

        // Mark current step as error, keep previous as success
        const newSteps = this.state.delete_steps.map((step, index) => ({
          ...step,
          status:
            index < this.state.delete_current_step
              ? "success"
              : index === this.state.delete_current_step
                ? "error"
                : "pending",
        }));

        this.setState({
          delete_steps: newSteps,
          is_deleting: false,
          delete_error: errorMessage,
        });
      });
  };

  // Execute bulk delete next batch sequentially
  executeBulkDeleteNextBatch = (stepIndex) => {
    const { delete_steps } = this.state;
    if (stepIndex >= delete_steps.length) {
      // Completed all batches!
      this.setState({
        is_deleting: false,
        delete_complete: true,
      });
      return;
    }

    // Set current step to running
    const newSteps = [...delete_steps];
    newSteps[stepIndex].status = "running";
    this.setState({ delete_steps: newSteps, delete_current_step: stepIndex });

    // Call bulk delete API for this batch
    const batchIds = delete_steps[stepIndex].ids;
    axios
      .post(
        this.state.url_delete_m,
        { id: batchIds },
        { headers: { Authorization: tokenApi } }
      )
      .then((res) => {
        if (res.data.status === false) {
          // Failed!
          const failedSteps = this.state.delete_steps.map((step, idx) => ({
            ...step,
            status: idx < stepIndex ? "success" : idx === stepIndex ? "error" : "pending"
          }));
          this.setState({
            delete_steps: failedSteps,
            is_deleting: false,
            delete_error: (res.data.messages && Array.isArray(res.data.messages)) 
              ? res.data.messages[0] 
              : (res.data.messages || "Gagal menghapus batch data user"),
          });
        } else {
          // Success for this batch, move to next!
          const successSteps = [...this.state.delete_steps];
          successSteps[stepIndex].status = "success";
          this.setState({ delete_steps: successSteps }, () => {
            this.executeBulkDeleteNextBatch(stepIndex + 1);
          });
        }
      })
      .catch((err) => {
        let errorMessage = "Terjadi kesalahan, silakan coba lagi";
        if (err.response && err.response.data) {
          const errorData = err.response.data;
          if (errorData.message) {
            errorMessage = errorData.message;
          } else if (errorData.messages) {
            errorMessage = Array.isArray(errorData.messages)
              ? errorData.messages[0]
              : errorData.messages;
          }
        }
        const failedSteps = this.state.delete_steps.map((step, idx) => ({
          ...step,
          status: idx < stepIndex ? "success" : idx === stepIndex ? "error" : "pending"
        }));
        this.setState({
          delete_steps: failedSteps,
          is_deleting: false,
          delete_error: errorMessage,
        });
      });
  };

  retryDelete = () => {
    if (this.state.delete_type === 'multiple') {
      const failedStepIndex = this.state.delete_steps.findIndex(
        (step) => step.status === "error" || step.status === "pending"
      );
      const startFrom = failedStepIndex >= 0 ? failedStepIndex : 0;
      
      const resetSteps = this.state.delete_steps.map((step, idx) => ({
        ...step,
        status: idx < startFrom ? "success" : "pending",
      }));

      this.setState(
        {
          delete_steps: resetSteps,
          delete_error: null,
          delete_current_step: startFrom,
          is_deleting: true,
        },
        () => {
          this.executeBulkDeleteNextBatch(startFrom);
        }
      );
      return;
    }

    // Reset steps and try again for single delete
    const newSteps = this.state.delete_steps.map((step) => ({
      ...step,
      status: "pending",
    }));
    this.setState({
      delete_steps: newSteps,
      delete_error: null,
      delete_current_step: 0,
    }, () => {
      this.executeDelete();
    });
  };

  checkAll(e) {
    e.preventDefault();
    this.setState({ loading_check: true }, function () {
      this.setState({ checkAll: true, loading_check: false });
    });
  }

  unCheckAll(e) {
    e.preventDefault();
    this.setState({ loading_check: true }, function () {
      this.setState({ checkAll: false, loading_check: false });
    });
  }

  deleteMulti() {
    var checkboxes = document.getElementsByName("check_data[]");
    var vals = [];
    for (var i = 0, n = checkboxes.length; i < n; i++) {
      if (checkboxes[i].checked) {
        vals.push(checkboxes[i].value);
      }
    }

    if (vals.length == 0) {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "warning",
        message_alert: "Mohon centang data terlebih dahulu",
        disabledFilter: false,
        checkAll: false,
        loading_delete: false,
      });
    } else {
      // Chunk size of 10 to prevent timeouts
      const batchSize = 10;
      const total = vals.length;
      const steps = [];
      for (let i = 0; i < total; i += batchSize) {
        const batchNum = Math.floor(i / batchSize) + 1;
        const end = Math.min(i + batchSize, total);
        steps.push({
          name: `Menghapus Batch ${batchNum} (${i + 1} - ${end} dari ${total} user lainnya)`,
          status: "pending",
          ids: vals.slice(i, i + batchSize)
        });
      }

      this.setState({
        modal_delete_progress: true,
        delete_type: 'multiple',
        delete_user_id: null,
        delete_user_ids: vals,
        delete_user_name: `Hapus Massal (${total} User Lainnya)`,
        delete_steps: steps,
        delete_current_step: 0,
        delete_error: null,
        is_deleting: false,
        delete_complete: false,
      });
    }
  }

  sendMailActivation() {
    this.setState({ loading_mail: true });
    var checkboxes = document.getElementsByName("check_data[]");
    var vals = [];
    var tokensEmpty = false;

    for (var i = 0, n = checkboxes.length; i < n; i++) {
      if (checkboxes[i].checked) {
        vals.push(checkboxes[i].value);
        const tokenElement = document.getElementById("token" + checkboxes[i].value);
        if (tokenElement && tokenElement.innerHTML.trim() === "") {
          tokensEmpty = true;
          break;
        }
      }
    }

    if (vals.length == 0) {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "warning",
        message_alert: "Mohon centang data terlebih dahulu",
        disabledFilter: false,
        loading_mail: false,
        checkAll: false,
      });
    } else if (tokensEmpty) {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "warning",
        message_alert: "Terdapat user yang belum memiliki token. Harap generate token terlebih dahulu.",
        loading_mail: false,
        checkAll: false,
      });
    } else {
      swal
        .fire({
          title: "Peringatan",
          text: "Apakah anda yakin mengirim email aktivasi user yang dipilih?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Iya`,
          cancelButtonText: "Batal",
        })
        .then((result) => {
          if (result.value == true) {
            axios
              .post(
                this.state.url_send_mail,
                { id: vals },
                { headers: { Authorization: tokenApi } }
              )
              .then((res) => {
                if (res.data.status == false) {
                  this.setState({
                    show_alert: true,
                    title_alert: "Gagal",
                    icon_alert: "error",
                    message_alert:
                      res.data.messages[0] +
                      "Berhasil : " +
                      res.data.berhasil +
                      "Gagal : " +
                      res.data.gagal,
                    loading_mail: false,
                    checkAll: false,
                  });
                  this.dt.loading();
                  this.dt.resetPage();
                } else {
                  this.setState({
                    show_alert: true,
                    title_alert: "Berhasil",
                    icon_alert: "success",
                    message_alert: res.data.messages[0],
                    loading_mail: false,
                    checkAll: false,
                  });
                  this.dt.loading();
                  this.dt.resetPage();
                }
              })
              .catch((err) => {
                this.setState({ loading_mail: false });
                // this.alertMessage(err.response);
              });
          } else if (result.dismiss == "cancel") {
            this.setState({ loading_mail: false });
          } else if (result.dismiss == "backdrop") {
            this.setState({ loading_mail: false });
          }
        });
    }
  }

  sendWAActivation() {
    this.setState({ loading_mail: true });
    var checkboxes = document.getElementsByName("check_data[]");
    var vals = [];
    var tokensEmpty = false;

    for (var i = 0, n = checkboxes.length; i < n; i++) {
      if (checkboxes[i].checked) {
        vals.push(checkboxes[i].value);
        const tokenElement = document.getElementById("token" + checkboxes[i].value);
        if (tokenElement && tokenElement.innerHTML.trim() === "") {
          tokensEmpty = true;
          break;
        }
      }
    }

    if (vals.length == 0) {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "warning",
        message_alert: "Mohon centang data terlebih dahulu",
        disabledFilter: false,
        loading_mail: false,
        checkAll: false,
      });
    } else if (tokensEmpty) {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "warning",
        message_alert: "Terdapat user yang belum memiliki token. Harap generate token terlebih dahulu.",
        loading_mail: false,
        checkAll: false,
      });
    } else {
      swal
        .fire({
          title: "Peringatan",
          text: "Apakah anda yakin mengirim email aktivasi user yang dipilih?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Iya`,
          cancelButtonText: "Batal",
        })
        .then((result) => {
          if (result.value == true) {
            axios
              .post(
                this.state.url_send_wa,
                { id: vals },
                { headers: { Authorization: tokenApi } }
              )
              .then((res) => {
                if (res.data.status == false) {
                  this.setState({
                    show_alert: true,
                    title_alert: "Gagal",
                    icon_alert: "error",
                    message_alert:
                      res.data.messages[0] +
                      "Berhasil : " +
                      res.data.berhasil +
                      "Gagal : " +
                      res.data.gagal,
                    loading_mail: false,
                    checkAll: false,
                  });
                  this.dt.loading();
                  this.dt.resetPage();
                } else {
                  this.setState({
                    show_alert: true,
                    title_alert: "Berhasil",
                    icon_alert: "success",
                    message_alert: res.data.messages[0],
                    loading_mail: false,
                    checkAll: false,
                  });
                  this.dt.loading();
                  this.dt.resetPage();
                }
              })
              .catch((err) => {
                this.setState({ loading_mail: false });
                // this.alertMessage(err.response);
              });
          } else if (result.dismiss == "cancel") {
            this.setState({ loading_mail: false });
          } else if (result.dismiss == "backdrop") {
            this.setState({ loading_mail: false });
          }
        });
    }
  }

  // Modal Detail
  showModalDetail(data) {
    this.setState({
      modal_detail: true,
      loading_detail: true,
    });
    axios
      .get(this.state.url_detail + data, {
        headers: { Authorization: tokenApi },
      })
      .then((res) => {
        this.setState({ data_detail: res.data.data, loading_detail: false });
      });
  }

  hideModalDetail() {
    this.setState({ modal_detail: false });
  }

  // Cetak Function
  showModalCetak() {
    this.setState(
      {
        modal_cetak: true,
        queryToken: `&paginate=10&search=`,
      },
      function () {
        this.dtt.fetchEntities(this.state.queryToken);
      }
    );
    // axios.get(`${this.state.url_table_token}/${this.state.institusi_id_select}?paginate=10`, {headers:{Authorization:tokenApi}}).then(res => {
    //   this.setState({ data_print: res.data, loading_print: false });
    // });
  }

  showTableToken() {
    if (this.state.queryToken != "") {
      return (
        <div>
          <DataTable
            ref={(dtt) => {
              this.dtt = dtt;
            }}
            action={{
              jenis_kelamin: (col, data) => {
                var jekel = "";
                if (col.jenis_kelamin == 1) {
                  jekel = "Laki - Laki";
                }

                if (col.jenis_kelamin == 0) {
                  jekel = "Perempuan";
                }

                if (col.jenis_kelamin == null) {
                  jekel = "Belum diketahui";
                }
                return <p className="text-sm">{jekel}</p>;
              },
              pilih: (col, data) => {
                return (
                  <input
                    type="checkbox"
                    name="check_data[]"
                    className="check"
                    id="check_data"
                    value={data.id}
                    defaultChecked={this.state.PilihSemua ? true : null}
                  />
                );
              },
            }}
            url={
              this.state.url_table_token + "/" + this.state.institusi_id_select
            }
            columns={[
              {
                index: "kode_pendaftaran",
                label: "Kode Pendaftaran",
              },
              {
                index: "token",
                label: "token",
              },
              {
                index: "nama",
                label: "nama",
              },
              {
                index: "jenis_kelamin",
                label: "Jenis Kelamin",
              },
              {
                index: "pilih",
                label: "pilih",
              },
            ]}
          />
        </div>
      );
    }
  }

  hideModalCetak() {
    this.setState({
      modal_cetak: false,
      queryToken: "",
      pilihSemua: false,
      searchToken: "",
      mode_show_token: 10,
    });
  }

  printToken(e) {
    e.preventDefault();
    this.setState({ loading_saveprint: true });
    var checkboxes = document.getElementsByName("check_data[]");
    var vals = "";
    var str = "";
    for (var i = 0, n = checkboxes.length; i < n; i++) {
      if (checkboxes[i].checked) {
        vals += "," + checkboxes[i].value;
        str = vals.substr(1);
      }
    }

    if (str == "") {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "error",
        message_alert: "Pilih atau centang User terlebih dahulu",
        loading_saveprint: false,
      });
    } else {
      axios
        .post(
          this.state.url_print_token,
          { id: str },
          { headers: { Authorization: tokenApi } }
        )
        .then((res) => {
          this.setState({ loading_saveprint: false });
          var mywindow = window.open("", "new div", "height=400,width=600");
          var jekel = ["Perempuan", "Laki - Laki"];
          res.data.map((person, index) => {
            mywindow.document.write(
              `<html>
              <head>
              </head>
              <body style="display: flex; flex-wrap: wrap; align-content: flex-start;">
                <table style="width:48%; margin-bottom:10px; margin-left: 10px; border-radius: 8px; padding: 4px;" border="1px solid #000000">
                  <tr>
                    <td style="border: 0px solid #000000; font-size: 11px;">KODE PENDAFTARAN</td>
                    <td style="border: 0px solid #000000; font-size: 11px; width: 60%;">: ${person.kode_pendaftaran
              }</td>
                  </tr>
                  <tr>
                    <td style="border: 0px solid #000000; font-size: 11px;">TOKEN</td>
                    <td style="border: 0px solid #000000; font-size: 11px; width: 60%;">: ${person.token
              }</td>
                  </tr>
                  <tr>
                    <td style="border: 0px solid #000000; font-size: 11px;">NAMA</td>
                    <td style="border: 0px solid #000000; font-size: 11px; width: 60%;">: ${person.nama
              }</td>
                  </tr>
                  <tr>
                    <td style="border: 0px solid #000000; font-size: 11px;">JENIS KELAMIN</td>
                    <td style="border: 0px solid #000000; font-size: 11px; width: 60%;">: ${jekel[person.jenis_kelamin]
              }</td>
                  </tr>
                </table>
              </body>
            </html>`
            );
          });
          mywindow.print();
          mywindow.close();
        })
        .catch((err) => {
          this.alertMessage(err.response);
          this.setState({ loading_saveprint: false });
        });
    }
  }

  // Generate All Token
  generateAllToken() {
    this.setState({ loading_generate_token: true });
    this.setState({ loading_token: true });
    axios
      .post(
        this.state.url_generate_all_token,
        { user_institusi_id: this.state.institusi_id_select },
        { headers: { Authorization: tokenApi } }
      )
      .then((res) => {
        this.setState({ loading_generate_token: false });
        this.setState({ loading_token: false });
        if (res.data.status === true) {
          this.dt.loading();
          this.dt.resetPage(
            `&status=${this.state.selectStatus}&paginate=${this.state.mode_show}&query=${this.state.query}`
          );
        } else {
          swal.fire({
            title: "Gagal",
            text: "Ada Kesalahan",
            icon: "error",
          });
        }
        this.setState({ loading_token: false });
      });
  }

  // Generate Token
  generate_token(data) {
    this.setState({ loading_token: data });
    axios
      .post(
        this.state.url_token_user,
        { user_id: data },
        { headers: { Authorization: tokenApi } }
      )
      .then((res) => {
        this.setState({ loading_token: false });
        document.getElementById("token" + data + "").innerHTML =
          "" + res.data.token + "";
        var element = document.getElementById("myButton" + data + "");
        element.classList.add("hidden");
      });
  }

  // reset search
  resetSearch(event) {
    event.preventDefault();
    document.getElementById("search").value = "";
    this.dt.fetchEntities(
      `&paginate=${this.state.mode_show}&query=${this.state.query}`
    );
  }

  export(event) {
    this.setState({ loading_export: true });
    event.preventDefault();
    axios({
      url: this.state.url_export_data + this.state.institusi_id_select,
      method: "POST",
      responseType: "blob", // important
      headers: { Authorization: tokenApi },
      data: {
        status: this.state.selectStatus,
      },
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        var tanggal = new Date();
        var bulan = tanggal.getMonth() + 1;
        if (bulan < 10 ? (bulan = `0${bulan}`) : "");
        link.setAttribute(
          "download",
          "Lainnya_" +
          tanggal.getDate() +
          "-" +
          bulan +
          "-" +
          tanggal.getFullYear() +
          "_TIME(" +
          tanggal.getHours() +
          "-" +
          tanggal.getMinutes() +
          ").xlsx"
        ); //or any other extension
        document.body.appendChild(link);
        link.click();
        this.setState({ loading_export: false });
      })
      .catch((err) => {
        this.alertMessage(err);
        this.setState({ loading_export: false });
      });
  }

  // Modal import
  showModalImport() {
    this.setState({ modal_import: true });
  }

  hideModalImport() {
    this.setState({ modal_import: false });
  }

  import(event) {
    event.preventDefault();

    this.setState({ simpleLoading: true });

    const data = new FormData();
    data.append("file", this.state.import_file);
    axios
      .post(this.state.url_import_data, data, {
        headers: { Authorization: tokenApi },
      })
      .then((res) => {
        if (res.data.status == false) {
          this.setState({
            show_alert: true,
            title_alert: "Gagal",
            icon_alert: "error",
            message_alert: res.data.messages[0],
            simpleLoading: false,
          });
        } else {
          this.showModalPrevImport(res.data.data);
          this.hideModalImport();
        }
      })
      .catch((err) => {
        this.setState({ simpleLoading: false });
        this.alertMessage(err.response);
      });
  }

  // Modal Import Detail
  showModalPrevImport(data) {
    this.setState({
      data_preview: data,
      modal_preview_import: true,
      simpleLoading: false,
    });
  }

  hideModalPrevImport() {
    this.setState({ modal_preview_import: false });
  }

  simpanImport(e) {
    e.preventDefault();
    this.setState({ simpleLoading: true });
    axios
      .post(
        this.state.url_save_import_data + this.state.institusi_id_select,
        { data: this.state.data_preview },
        { headers: { Authorization: tokenApi } }
      )
      .then((res) => {
        this.setState({ simpleLoading: false });
        if (res.data.status == false) {
          this.setState({
            show_alert: true,
            title_alert: "Gagal",
            icon_alert: "error",
            message_alert: res.data.messages[0],
            simpleLoading: false,
          });
        } else {
          this.setState({
            show_alert: true,
            title_alert: res.data.title[0],
            icon_alert: res.data.icon[0],
            message_alert: res.data.messages[0],
            simpleLoading: false,
          });
          this.hideModalPrevImport();
          this.dt.fetchEntities(
            `&paginate=${this.state.mode_show}&query=${this.state.query}`
          );
        }
      })
      .catch((err) => {
        this.setState({ simpleLoading: false });
        this.alertMessage(err.response);
      });
  }

  searchText(e) {
    e.preventDefault();
    this.setState(
      { query: document.getElementById("search").value },
      function () {
        this.dt.loading();
        this.dt.resetPage(
          `&paginate=${this.state.mode_show}&query=${this.state.query}`
        );
      }
    );
  }

  changeStatus = (e) => {
    if (e) {
      this.setState(
        {
          selectStatus: e.value,
        },
        function () {
          this.dt.loading();
          this.dt.resetPage(
            `&status=${this.state.selectStatus}&paginate=${this.state.mode_show}&query=${this.state.query}`
          );
        }
      );
    } else {
      this.dt.loading();
      this.dt.resetPage(
        `&paginate=${this.state.mode_show}&query=${this.state.query}`
      );
    }
  };

  pilihSemua() {
    var checkboxes = document.getElementsByClassName("select-all").item(0)
      .checked;
    if (checkboxes == true) {
      this.setState({ PilihSemua: true }, function () {
        this.dtt.loading();
        this.dtt.fetchEntities(this.state.queryToken);
      });
    } else {
      this.setState({ PilihSemua: false }, function () {
        this.dtt.loading();
        this.dtt.fetchEntities(this.state.queryToken);
      });
    }
  }

  // Menampilkan modal dropzone foto profil
  showModalDropzoneImage() {
    this.setState({ modal_image: true });
  }

  // Tutup modal dropzone foto profil
  hideModalDropzoneImage() {
    this.setState({ modal_image: false });
  }

  // Generate Activation Code Modal Functions
  showModalGenerateActivation() {
    this.setState({
      modal_generate_activation: true,
      activation_tahun_ajaran: "",
      activation_prefix: "",
      activation_jumlah_token: "",
      activation_token_sama: false,
      activation_mode: "auto",
      activation_manual_list: [{ kode_pendaftaran: "", token: "" }]
    });
  }

  hideModalGenerateActivation() {
    this.setState({
      modal_generate_activation: false,
      activation_tahun_ajaran: "",
      activation_prefix: "",
      activation_jumlah_token: "",
      activation_token_sama: false,
      activation_mode: "auto",
      activation_manual_list: [{ kode_pendaftaran: "", token: "" }]
    });
  }

  activationTahunAjaran(e) {
    this.setState({ activation_tahun_ajaran: e.value });
  }

  activationPrefix(e) {
    this.setState({ activation_prefix: e.target.value });
  }

  activationJumlahToken(e) {
    this.setState({ activation_jumlah_token: e.target.value });
  }

  activationTokenSama(e) {
    this.setState({ activation_token_sama: e.target.checked });
  }

  // Ganti mode antara "auto" (jumlah saja) dan "manual" (isi kode & token sendiri)
  activationSetMode(mode) {
    this.setState({
      activation_mode: mode,
      activation_manual_list:
        mode === "manual" && this.state.activation_manual_list.length === 0
          ? [{ kode_pendaftaran: "", token: "" }]
          : this.state.activation_manual_list
    });
  }

  // Ubah nilai kode_pendaftaran / token pada baris manual tertentu
  activationManualChange(index, field, value) {
    const list = [...this.state.activation_manual_list];
    list[index] = { ...list[index], [field]: value };
    this.setState({ activation_manual_list: list });
  }

  // Tambah baris input manual baru
  activationAddManualRow() {
    this.setState({
      activation_manual_list: [
        ...this.state.activation_manual_list,
        { kode_pendaftaran: "", token: "" }
      ]
    });
  }

  // Hapus baris input manual
  activationRemoveManualRow(index) {
    const list = [...this.state.activation_manual_list];
    if (list.length <= 1) return; // minimal 1 baris
    list.splice(index, 1);
    this.setState({ activation_manual_list: list });
  }

  generateActivationCodes(e) {
    e.preventDefault();

    const isManual = this.state.activation_mode === "manual";

    let jumlah_token;
    let kode_pendaftaran_arr = [];
    let token_arr = [];

    if (isManual) {
      // Validasi mode manual: setiap baris wajib punya kode_pendaftaran & token
      const list = this.state.activation_manual_list;
      const invalid = list.some(
        (row) => !row.kode_pendaftaran || !row.token
      );

      if (list.length === 0 || invalid) {
        this.setState({
          show_alert: true,
          title_alert: "Validasi",
          icon_alert: "warning",
          message_alert: "Kode pendaftaran dan token wajib diisi untuk setiap baris!"
        });
        return;
      }

      jumlah_token = list.length;
      kode_pendaftaran_arr = list.map((row) => row.kode_pendaftaran);
      token_arr = list.map((row) => row.token);
    } else {
      if (!this.state.activation_jumlah_token || this.state.activation_jumlah_token <= 0) {
        this.setState({
          show_alert: true,
          title_alert: "Validasi",
          icon_alert: "warning",
          message_alert: "Jumlah token harus diisi dan lebih dari 0!"
        });
        return;
      }
      jumlah_token = parseInt(this.state.activation_jumlah_token);
    }

    this.setState({ loading_generate_activation: true });

    const data = {
      user_institusi_id: this.state.institusi_id_select,
      // tahun_ajaran: this.state.activation_tahun_ajaran,
      prefix: this.state.activation_prefix || "",
      jumlah_token: jumlah_token,
      token_sama: isManual ? false : this.state.activation_token_sama
    };

    if (isManual) {
      data.kode_pendaftaran = kode_pendaftaran_arr;
      data.token = token_arr;
    }

    axios
      .post(this.state.url_generate_activation, data, {
        headers: { Authorization: tokenApi }
      })
      .then((res) => {
        this.setState({ loading_generate_activation: false });
        if (res.data.status) {
          const totalCreated = res.data.data?.total_created ?? 0;
          const totalFailed = res.data.data?.total_failed ?? 0;
          const failedList = res.data.data?.failed ?? [];

          if (totalCreated === 0) {
            // Tidak ada satupun token yang berhasil dibuat (mis. kode/token
            // sudah dipakai) -> jangan tampilkan sebagai berhasil
            const friendlyReason = (reason) => {
              if (!reason) return "gagal dibuat";
              if (reason.toLowerCase().includes("sudah dipakai")) return "sudah pernah digunakan";
              if (reason.toLowerCase().includes("sudah ada setelah")) return "gagal dibuat karena bentrok dengan kode lain";
              return reason;
            };
            const failReasons = failedList
              .map((f) => `Kode ${f.kode_pendaftaran} ${friendlyReason(f.reason)}`)
              .join(", ");
            this.setState({
              show_alert: true,
              title_alert: "Gagal",
              icon_alert: "error",
              message_alert: failReasons
                ? `${failReasons}.`
                : res.data.message
            });
            return;
          }

          if (totalFailed > 0) {
            // Sebagian berhasil, sebagian gagal
            this.setState({
              show_alert: true,
              title_alert: "Sebagian Berhasil",
              icon_alert: "warning",
              message_alert: res.data.message,
              modal_generate_activation: false
            });
          } else {
            this.setState({
              show_alert: true,
              title_alert: "Berhasil",
              icon_alert: "success",
              message_alert: res.data.message,
              modal_generate_activation: false
            });
          }
          // Refresh data table
          this.dt.loading();
          this.dt.resetPage();
        } else {
          this.setState({
            show_alert: true,
            title_alert: "Gagal",
            icon_alert: "error",
            message_alert: res.data.message || "Gagal membuat kode aktivasi"
          });
        }
      })
      .catch((err) => {
        this.setState({ loading_generate_activation: false });
        let errorMessage = "Terjadi kesalahan sistem";
        if (err.response && err.response.data && err.response.data.messages) {
          errorMessage = Array.isArray(err.response.data.messages)
            ? err.response.data.messages.join(", ")
            : err.response.data.messages;
        }
        this.setState({
          show_alert: true,
          title_alert: "Error",
          icon_alert: "error",
          message_alert: errorMessage
        });
      });
  }

  render() {
    return (
      <div>
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm mx-auto p-6 mt-6 sm-container">
          <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4">
            <div>
              <div className="flex items-center gap-2">
                <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-blue-50 text-blue-600">
                  <i className="bx bxs-user text-xl"></i>
                </span>
                <h1 className="text-xl font-bold text-gray-900">
                  Manajemen Staf & Lainnya
                </h1>
              </div>
              <p className="text-gray-500 text-sm mt-1">
                Kelola data akun staf lainnya, buat token, export data, dan atur kode aktivasi.
              </p>
            </div>
            <div className="flex flex-wrap gap-2 items-center">
              {this.state.institusi_id_select != "" ? (
                <>
                  <button
                    onClick={this.generateAllToken}
                    className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-gray-700 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 transition-all duration-200 shadow-sm"
                    disabled={this.state.loading_generate_token ? true : false}
                  >
                    {this.state.loading_generate_token ? (
                      <UserButtonLoading color="text-gray-700" />
                    ) : (
                      <>
                        <i className="bx bx-doughnut-chart text-lg"></i>{" "}
                        Generate Token
                      </>
                    )}
                  </button>
                  <button
                    onClick={this.showModalGenerateActivation}
                    className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-gray-700 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 transition-all duration-200 shadow-sm"
                  >
                    <i className="bx bx-key text-lg"></i> Generate Activation
                  </button>
                  <button
                    onClick={this.export}
                    className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-gray-700 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 transition-all duration-200 shadow-sm"
                    disabled={this.state.loading_export ? true : false}
                  >
                    {this.state.loading_export ? (
                      <UserButtonLoading color="text-gray-700" />
                    ) : (
                      <>
                        <i className="bx bx-export text-lg"></i> Export
                      </>
                    )}
                  </button>
                  <button
                    onClick={this.showModalImport}
                    className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-gray-700 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 transition-all duration-200 shadow-sm"
                  >
                    <i className="bx bx-upload text-lg"></i> Upload
                  </button>
                  <button
                    onClick={this.showModalCetak}
                    className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-gray-700 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 transition-all duration-200 shadow-sm"
                  >
                    <i className="bx bx-printer text-lg"></i> Cetak
                  </button>
                  <button
                    className="flex items-center justify-center gap-1.5 px-5 py-2 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-xl transition-all duration-200 shadow-md shadow-blue-500/10 active:scale-95"
                    onClick={this.showModalTambah}
                  >
                    <i className="bx bx-plus text-lg"></i>
                    Tambah
                  </button>

                  <button
                    onClick={this.showModalDropzoneImage}
                    className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-gray-700 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 transition-all duration-200 shadow-sm"
                  >
                    <i className="bx bx-upload text-lg"></i> Foto Profil
                  </button>
                </>
              ) : (
                <>
                  <div className="w-20 px-2">
                    {" "}
                    <Skeleton height={20} className="bg-gray-400" />{" "}
                  </div>
                  <div className="w-20 px-2">
                    {" "}
                    <Skeleton height={20} className="bg-gray-400" />{" "}
                  </div>
                  <div className="w-20 px-2">
                    {" "}
                    <Skeleton height={20} className="bg-gray-400" />{" "}
                  </div>
                  <div className="w-20 px-2">
                    {" "}
                    <Skeleton height={20} className="bg-gray-400" />{" "}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        {/* alert */}
        <SweetAlert
          show={this.state.show_alert}
          title={this.state.title_alert}
          text={this.state.message_alert}
          type={this.state.icon_alert}
          onConfirm={() => this.setState({ show_alert: false })}
          onOutsideClick={() => this.setState({ show_alert: false })}
        />

        {/* Modal dropzone foto profil */}
        <ModalDropZoneImage showModal={this.state.modal_image} hideModal={this.hideModalDropzoneImage} type="LA" />

        {/* Delete Progress Modal */}
        <DeleteProgressModal
          show={this.state.modal_delete_progress}
          onHide={this.hideDeleteProgressModal}
          steps={this.state.delete_steps}
          error={this.state.delete_error}
          onConfirm={this.executeDelete}
          onRetry={this.retryDelete}
          isDeleting={this.state.is_deleting}
          isComplete={this.state.delete_complete}
          userName={this.state.delete_user_name}
          userType="Lainnya"
        />

        {/* Modal Generate Activation */}
        <Modal show={this.state.modal_generate_activation} onHide={this.hideModalGenerateActivation}>
          <Modal.Header>Generate Kode Aktivasi</Modal.Header>
          <Modal.Body>
            {/* Toggle Mode: Otomatis vs Manual */}
            <div className="w-full flex gap-2 mb-2">
              <button
                type="button"
                onClick={() => this.activationSetMode("auto")}
                className={
                  this.state.activation_mode === "auto"
                    ? "flex-1 px-4 py-2 text-sm font-semibold text-white bg-blue-600 rounded-full"
                    : "flex-1 px-4 py-2 text-sm font-semibold text-gray-700 bg-gray-100 rounded-full"
                }
              >
                Otomatis
              </button>
              <button
                type="button"
                onClick={() => this.activationSetMode("manual")}
                className={
                  this.state.activation_mode === "manual"
                    ? "flex-1 px-4 py-2 text-sm font-semibold text-white bg-blue-600 rounded-full"
                    : "flex-1 px-4 py-2 text-sm font-semibold text-gray-700 bg-gray-100 rounded-full"
                }
              >
                Manual
              </button>
            </div>

            <form onSubmit={this.generateActivationCodes}>
              {/* <div className="w-full mt-3">
                <label className="mb-2 ml-2 text-gray-800 block text-sm mt-3">
                  Tahun Ajaran <span className="text-red-500">*</span>
                </label>
                <Select
                  styles={selectStyles}
                  className="react-select__control w-100"
                  placeholder="Pilih Tahun Ajaran"
                  options={this.state.data_tahun_ajaran}
                  onChange={this.activationTahunAjaran}
                />
              </div> */}

              {this.state.activation_mode === "auto" ? (
                <>
                  <div className="w-full mt-3">
                    <label className="mb-2 ml-2 text-gray-800 block text-sm mt-3">
                      Prefix (Opsional)
                    </label>
                    <input
                      type="text"
                      className="w-full pl-4 pr-4 my-0 py-2 rounded-full border border-gray-500 focus:outline-none focus:shadow-outline text-gray-800"
                      placeholder="Masukkan prefix untuk token (contoh: LA)"
                      onChange={this.activationPrefix}
                      value={this.state.activation_prefix}
                    />
                  </div>
                  <div className="w-full mt-3">
                    <label className="mb-2 ml-2 text-gray-800 block text-sm mt-3">
                      Jumlah Token <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="number"
                      min="1"
                      className="w-full pl-4 pr-4 my-0 py-2 rounded-full border border-gray-500 focus:outline-none focus:shadow-outline text-gray-800"
                      placeholder="Masukkan jumlah token yang akan digenerate"
                      onChange={this.activationJumlahToken}
                      value={this.state.activation_jumlah_token}
                    />
                  </div>
                  {/* <div className="w-full mt-3">
                    <label className="inline-flex items-center align-middle ml-2">
                      <input
                        type="checkbox"
                        className="form-checkbox"
                        onChange={this.activationTokenSama}
                        checked={this.state.activation_token_sama}
                      />
                      <span className="ml-2 text-gray-800 block text-sm">
                        Generate token yang sama untuk semua user
                      </span>
                    </label>
                  </div> */}
                </>
              ) : (
                <div className="w-full mt-3">
                  <label className="mb-2 ml-2 text-gray-800 block text-sm">
                    Kode Pendaftaran &amp; Token <span className="text-red-500">*</span>
                  </label>
                  <div className="max-h-64 overflow-y-auto pr-1">
                    {this.state.activation_manual_list.map((row, index) => (
                      <div key={index} className="flex gap-2 items-center mb-2">
                        <input
                          type="text"
                          className="w-1/2 pl-4 pr-4 py-2 rounded-full border border-gray-500 focus:outline-none focus:shadow-outline text-gray-800 text-sm"
                          placeholder="Kode Pendaftaran"
                          value={row.kode_pendaftaran}
                          onChange={(e) =>
                            this.activationManualChange(index, "kode_pendaftaran", e.target.value)
                          }
                        />
                        <input
                          type="text"
                          className="w-1/2 pl-4 pr-4 py-2 rounded-full border border-gray-500 focus:outline-none focus:shadow-outline text-gray-800 text-sm"
                          placeholder="Token"
                          value={row.token}
                          onChange={(e) =>
                            this.activationManualChange(index, "token", e.target.value)
                          }
                        />
                        <button
                          type="button"
                          onClick={() => this.activationRemoveManualRow(index)}
                          className="btn-red text-white w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-full"
                          disabled={this.state.activation_manual_list.length <= 1}
                        >
                          <i className="bx bx-trash"></i>
                        </button>
                      </div>
                    ))}
                  </div>
                  <button
                    type="button"
                    onClick={this.activationAddManualRow}
                    className="btn-default flex items-center gap-1 px-4 py-2 text-sm rounded-full mt-1"
                  >
                    <i className="bx bx-plus"></i> Tambah Baris
                  </button>
                  <p className="text-xs text-gray-500 ml-2 mt-2">
                    Jumlah token yang akan dibuat: {this.state.activation_manual_list.length}
                  </p>
                </div>
              )}

              <input
                type="submit"
                className={
                  this.state.loading_generate_activation
                    ? "btn-disabled px-4 flex items-center rounded-full py-2 mt-3 text-sm"
                    : "btn-schoolmedia px-4 flex items-center rounded-full text-white py-2 mt-3 text-sm"
                }
                value={this.state.loading_generate_activation ? "Tunggu..." : "Generate"}
                disabled={this.state.loading_generate_activation ? true : false}
              />
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn-default mx-1 px-4 py-2 justify-center font-medium rounded-full text-gray-800 items-center text-sm"
              onClick={this.hideModalGenerateActivation}
            >
              Tutup
            </button>
          </Modal.Footer>
        </Modal>

        {/* modal tambah - Premium Design */}
        <Modal
          show={this.state.modal_tambah}
          onHide={this.hideModalTambah}
          size="lg"
          centered
          contentClassName="rounded-xl border-0 shadow-2xl overflow-hidden"
        >
          <div
            className="px-6 py-4"
            style={{
              background: "linear-gradient(135deg, #059669 0%, #10b981 50%, #34d399 100%)",
            }}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center mr-4"
                  style={{ background: "rgba(255,255,255,0.2)" }}
                >
                  <i className="bx bx-user-plus text-white text-2xl"></i>
                </div>
                <div>
                  <h5 className="text-lg font-bold text-white m-0">
                    Tambah User Lainnya
                  </h5>
                  <p className="text-sm text-white m-0 mt-1" style={{ opacity: 0.9 }}>
                    Staff / Karyawan / Pengguna Lainnya
                  </p>
                </div>
              </div>
              <button
                type="button"
                className="text-white hover:bg-white hover:bg-opacity-20 rounded-lg p-2 transition-all"
                onClick={this.hideModalTambah}
              >
                <i className="bx bx-x text-2xl"></i>
              </button>
            </div>
          </div>

          <Modal.Body className="p-6">
            <form onSubmit={this.create}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Left Column - Identitas */}
                <div
                  className="p-5 rounded-xl border-2"
                  style={{ borderColor: "#d1fae5", background: "#f0fdf4" }}
                >
                  <div className="flex items-center mb-4">
                    <div
                      className="w-8 h-8 rounded-lg flex items-center justify-center mr-3"
                      style={{ background: "linear-gradient(135deg, #059669, #10b981)" }}
                    >
                      <i className="bx bx-id-card text-white text-lg"></i>
                    </div>
                    <h6 className="font-semibold text-gray-800 m-0">Data Identitas</h6>
                  </div>

                  {/* NIK/Kode Pendaftaran */}
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Kode Pendaftaran <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <input
                        type="text"
                        className={`w-full px-4 py-3 rounded-xl border-2 focus:outline-none transition-all ${this.state.nikAvailable === true
                          ? "border-green-400 bg-green-50"
                          : this.state.nikAvailable === false
                            ? "border-red-400 bg-red-50"
                            : "border-gray-200 focus:border-emerald-400"
                          }`}
                        placeholder="NIK / NIP / No Pegawai"
                        value={this.state.nik}
                        onChange={(e) => {
                          this.setState({ nik: e.target.value });
                          this.checkNikAvailability(e.target.value);
                        }}
                      />
                      {this.state.checkingNik && (
                        <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                          <div className="animate-spin w-5 h-5 border-2 border-emerald-500 border-t-transparent rounded-full"></div>
                        </div>
                      )}
                      {!this.state.checkingNik && this.state.nikAvailable === true && (
                        <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                          <i className="bx bx-check-circle text-green-500 text-xl"></i>
                        </div>
                      )}
                      {!this.state.checkingNik && this.state.nikAvailable === false && (
                        <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                          <i className="bx bx-x-circle text-red-500 text-xl"></i>
                        </div>
                      )}
                    </div>
                    {this.state.nikAvailable === false && this.state.nikMessage && (
                      <p className="text-red-500 text-xs mt-1">{this.state.nikMessage}</p>
                    )}
                  </div>

                  {/* Nama */}
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Nama Lengkap <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-emerald-400 focus:outline-none transition-all"
                      placeholder="Masukkan nama lengkap"
                      value={this.state.nama}
                      onChange={this.nama}
                    />
                  </div>

                  {/* Jenis Kelamin */}
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Jenis Kelamin <span className="text-red-500">*</span>
                    </label>
                    <div className="flex gap-4">
                      <label className="flex items-center cursor-pointer">
                        <input
                          type="radio"
                          name="jenis_kelamin_add"
                          value="1"
                          checked={this.state.jenis_kelamin === "1"}
                          onChange={this.jenis_kelamin}
                          className="w-4 h-4 text-emerald-600"
                        />
                        <span className="ml-2 text-sm text-gray-700">Laki-laki</span>
                      </label>
                      <label className="flex items-center cursor-pointer">
                        <input
                          type="radio"
                          name="jenis_kelamin_add"
                          value="0"
                          checked={this.state.jenis_kelamin === "0"}
                          onChange={this.jenis_kelamin}
                          className="w-4 h-4 text-emerald-600"
                        />
                        <span className="ml-2 text-sm text-gray-700">Perempuan</span>
                      </label>
                    </div>
                  </div>

                  {/* Tanggal Lahir */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Tanggal Lahir <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="date"
                      className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-emerald-400 focus:outline-none transition-all"
                      value={this.state.tanggal_lahir}
                      onChange={this.tanggal_lahir}
                    />
                  </div>
                </div>

                {/* Right Column - Akun & Kontak */}
                <div
                  className="p-5 rounded-xl border-2"
                  style={{ borderColor: "#fef3c7", background: "#fffbeb" }}
                >
                  <div className="flex items-center mb-4">
                    <div
                      className="w-8 h-8 rounded-lg flex items-center justify-center mr-3"
                      style={{ background: "linear-gradient(135deg, #d97706, #f59e0b)" }}
                    >
                      <i className="bx bx-key text-white text-lg"></i>
                    </div>
                    <h6 className="font-semibold text-gray-800 m-0">Akun & Kontak</h6>
                  </div>

                  {/* Username */}
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Username <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <input
                        type="text"
                        className={`w-full px-4 py-3 rounded-xl border-2 focus:outline-none transition-all ${this.state.usernameAvailable === true
                          ? "border-green-400 bg-green-50"
                          : this.state.usernameAvailable === false
                            ? "border-red-400 bg-red-50"
                            : "border-gray-200 focus:border-amber-400"
                          }`}
                        placeholder="username_baru"
                        value={this.state.username}
                        onChange={(e) => {
                          const val = e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, "");
                          this.setState({ username: val });
                          this.checkUsernameAvailability(val);
                        }}
                      />
                      {this.state.checkingUsername && (
                        <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                          <div className="animate-spin w-5 h-5 border-2 border-amber-500 border-t-transparent rounded-full"></div>
                        </div>
                      )}
                      {!this.state.checkingUsername && this.state.usernameAvailable === true && (
                        <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                          <i className="bx bx-check-circle text-green-500 text-xl"></i>
                        </div>
                      )}
                      {!this.state.checkingUsername && this.state.usernameAvailable === false && (
                        <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                          <i className="bx bx-x-circle text-red-500 text-xl"></i>
                        </div>
                      )}
                    </div>
                    {this.state.usernameAvailable === false && this.state.usernameRecommendations.length > 0 && (
                      <div className="mt-2">
                        <p className="text-xs text-gray-600 mb-1">Saran username:</p>
                        <div className="flex flex-wrap gap-1">
                          {this.state.usernameRecommendations.map((rec, idx) => (
                            <button
                              key={idx}
                              type="button"
                              className="px-2 py-1 bg-amber-100 text-amber-700 rounded text-xs hover:bg-amber-200"
                              onClick={() => {
                                this.setState({ username: rec });
                                this.checkUsernameAvailability(rec);
                              }}
                            >
                              {rec}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Email */}
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Email <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <input
                        type="email"
                        className={`w-full px-4 py-3 rounded-xl border-2 focus:outline-none transition-all ${this.state.emailAvailable === true
                          ? "border-green-400 bg-green-50"
                          : this.state.emailAvailable === false
                            ? "border-red-400 bg-red-50"
                            : "border-gray-200 focus:border-amber-400"
                          }`}
                        placeholder="email@domain.com"
                        value={this.state.email}
                        onChange={(e) => {
                          const val = e.target.value.toLowerCase();
                          this.setState({ email: val });
                          this.checkEmailAvailability(val);
                        }}
                      />
                      {this.state.checkingEmail && (
                        <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                          <div className="animate-spin w-5 h-5 border-2 border-amber-500 border-t-transparent rounded-full"></div>
                        </div>
                      )}
                      {!this.state.checkingEmail && this.state.emailAvailable === true && (
                        <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                          <i className="bx bx-check-circle text-green-500 text-xl"></i>
                        </div>
                      )}
                      {!this.state.checkingEmail && this.state.emailAvailable === false && (
                        <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                          <i className="bx bx-x-circle text-red-500 text-xl"></i>
                        </div>
                      )}
                    </div>
                    {this.state.emailAvailable === false && this.state.emailMessage && (
                      <p className="text-red-500 text-xs mt-1">{this.state.emailMessage}</p>
                    )}
                  </div>

                  {/* Password */}
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Password <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <input
                        type={this.state.showPassword ? "text" : "password"}
                        className="w-full px-4 py-3 pr-12 rounded-xl border-2 border-gray-200 focus:border-amber-400 focus:outline-none transition-all"
                        placeholder="Minimal 8 karakter"
                        value={this.state.password}
                        onChange={(e) => {
                          this.setState({ password: e.target.value });
                          this.checkPasswordStrength(e.target.value);
                        }}
                      />
                      <button
                        type="button"
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                        onClick={this.togglePasswordVisibility}
                      >
                        <i className={`bx ${this.state.showPassword ? "bx-hide" : "bx-show"} text-xl`}></i>
                      </button>
                    </div>
                    {this.state.password && (
                      <div className="mt-2">
                        <div className="flex items-center gap-2">
                          <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
                            <div
                              className={`h-full transition-all ${this.state.passwordStrength === "weak"
                                ? "w-1/3 bg-red-500"
                                : this.state.passwordStrength === "medium"
                                  ? "w-2/3 bg-yellow-500"
                                  : "w-full bg-green-500"
                                }`}
                            ></div>
                          </div>
                          <span
                            className={`text-xs font-medium ${this.state.passwordStrength === "weak"
                              ? "text-red-500"
                              : this.state.passwordStrength === "medium"
                                ? "text-yellow-600"
                                : "text-green-500"
                              }`}
                          >
                            {this.state.passwordStrengthText}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* No Telepon */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      No. Handphone
                    </label>
                    <input
                      type="tel"
                      className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-amber-400 focus:outline-none transition-all"
                      placeholder="08xxxxxxxxxx"
                      value={this.state.no_telepon}
                      onChange={this.no_telepon}
                    />
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                <button
                  type="button"
                  className="px-6 py-2.5 rounded-xl border-2 border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition-all"
                  onClick={this.hideModalTambah}
                >
                  Batal
                </button>
                <button
                  type="submit"
                  disabled={this.state.simpleLoading || this.state.usernameAvailable === false || this.state.emailAvailable === false || this.state.nikAvailable === false}
                  className="px-6 py-2.5 rounded-xl text-white font-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                  style={{
                    background: this.state.simpleLoading
                      ? "#9ca3af"
                      : "linear-gradient(135deg, #059669 0%, #10b981 100%)",
                  }}
                >
                  {this.state.simpleLoading ? (
                    <span className="flex items-center">
                      <div className="animate-spin w-4 h-4 border-2 border-white border-t-transparent rounded-full mr-2"></div>
                      Menyimpan...
                    </span>
                  ) : (
                    <span className="flex items-center">
                      <i className="bx bx-save mr-2"></i>
                      Simpan
                    </span>
                  )}
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>

        {/* modal Edit - Premium Design */}
        <Modal
          show={this.state.modal_edit}
          onHide={this.hideModalEdit}
          size="lg"
          centered
          contentClassName="rounded-xl border-0 shadow-2xl overflow-hidden"
        >
          <div
            className="px-6 py-4"
            style={{
              background: "linear-gradient(135deg, #0891b2 0%, #06b6d4 50%, #22d3ee 100%)",
            }}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center mr-4"
                  style={{ background: "rgba(255,255,255,0.2)" }}
                >
                  <i className="bx bx-edit text-white text-2xl"></i>
                </div>
                <div>
                  <h5 className="text-lg font-bold text-white m-0">
                    Edit User Lainnya
                  </h5>
                  <p className="text-sm text-white m-0 mt-1" style={{ opacity: 0.9 }}>
                    {this.state.nama || "Staff / Karyawan"}
                    {this.state.userStatus && (
                      <span
                        className="ml-2 px-2 py-0.5 rounded-full text-xs"
                        style={{
                          background: this.state.userStatus === "Active" ? "rgba(34,197,94,0.3)" : "rgba(234,179,8,0.3)",
                        }}
                      >
                        {this.state.userStatus}
                      </span>
                    )}
                  </p>
                </div>
              </div>
              <button
                type="button"
                className="text-white hover:bg-white hover:bg-opacity-20 rounded-lg p-2 transition-all"
                onClick={this.hideModalEdit}
              >
                <i className="bx bx-x text-2xl"></i>
              </button>
            </div>
          </div>

          {this.state.loading_edit ? (
            <UserEditSkeleton />
          ) : (
            <Modal.Body className="p-6">
              <form onSubmit={this.update}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Left Column - Identitas */}
                  <div
                    className="p-5 rounded-xl border-2"
                    style={{ borderColor: "#cffafe", background: "#ecfeff" }}
                  >
                    <div className="flex items-center mb-4">
                      <div
                        className="w-8 h-8 rounded-lg flex items-center justify-center mr-3"
                        style={{ background: "linear-gradient(135deg, #0891b2, #06b6d4)" }}
                      >
                        <i className="bx bx-id-card text-white text-lg"></i>
                      </div>
                      <h6 className="font-semibold text-gray-800 m-0">Data Identitas</h6>
                    </div>

                    {/* NIK/Kode Pendaftaran */}
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Kode Pendaftaran <span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <input
                          type="text"
                          className={`w-full px-4 py-3 rounded-xl border-2 focus:outline-none transition-all ${this.state.nikAvailable === true
                            ? "border-green-400 bg-green-50"
                            : this.state.nikAvailable === false
                              ? "border-red-400 bg-red-50"
                              : "border-gray-200 focus:border-cyan-400"
                            }`}
                          placeholder="NIK / NIP / No Pegawai"
                          value={this.state.nik}
                          onChange={(e) => {
                            this.setState({ nik: e.target.value });
                            this.checkNikAvailability(e.target.value);
                          }}
                        />
                        {this.state.checkingNik && (
                          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                            <div className="animate-spin w-5 h-5 border-2 border-cyan-500 border-t-transparent rounded-full"></div>
                          </div>
                        )}
                        {!this.state.checkingNik && this.state.nikAvailable === true && (
                          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                            <i className="bx bx-check-circle text-green-500 text-xl"></i>
                          </div>
                        )}
                        {!this.state.checkingNik && this.state.nikAvailable === false && (
                          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                            <i className="bx bx-x-circle text-red-500 text-xl"></i>
                          </div>
                        )}
                      </div>
                      {this.state.nikAvailable === false && this.state.nikMessage && (
                        <p className="text-red-500 text-xs mt-1">{this.state.nikMessage}</p>
                      )}
                    </div>

                    {/* Nama */}
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Nama Lengkap <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-cyan-400 focus:outline-none transition-all"
                        placeholder="Masukkan nama lengkap"
                        value={this.state.nama}
                        onChange={this.nama}
                      />
                    </div>

                    {/* Jenis Kelamin */}
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Jenis Kelamin <span className="text-red-500">*</span>
                      </label>
                      <div className="flex gap-4">
                        <label className="flex items-center cursor-pointer">
                          <input
                            type="radio"
                            name="jenis_kelamin_edit"
                            value="1"
                            checked={this.state.jenis_kelamin === "1" || this.state.jenis_kelamin === 1}
                            onChange={this.jenis_kelamin}
                            className="w-4 h-4 text-cyan-600"
                          />
                          <span className="ml-2 text-sm text-gray-700">Laki-laki</span>
                        </label>
                        <label className="flex items-center cursor-pointer">
                          <input
                            type="radio"
                            name="jenis_kelamin_edit"
                            value="0"
                            checked={this.state.jenis_kelamin === "0" || this.state.jenis_kelamin === 0}
                            onChange={this.jenis_kelamin}
                            className="w-4 h-4 text-cyan-600"
                          />
                          <span className="ml-2 text-sm text-gray-700">Perempuan</span>
                        </label>
                      </div>
                    </div>

                    {/* Tanggal Lahir */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Tanggal Lahir <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="date"
                        className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-cyan-400 focus:outline-none transition-all"
                        value={this.state.tanggal_lahir}
                        onChange={this.tanggal_lahir}
                      />
                    </div>
                  </div>

                  {/* Right Column - Akun & Kontak */}
                  <div
                    className="p-5 rounded-xl border-2"
                    style={{ borderColor: "#fef3c7", background: "#fffbeb" }}
                  >
                    <div className="flex items-center mb-4">
                      <div
                        className="w-8 h-8 rounded-lg flex items-center justify-center mr-3"
                        style={{ background: "linear-gradient(135deg, #d97706, #f59e0b)" }}
                      >
                        <i className="bx bx-key text-white text-lg"></i>
                      </div>
                      <h6 className="font-semibold text-gray-800 m-0">Akun & Kontak</h6>
                    </div>

                    {/* Username */}
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Username <span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <input
                          type="text"
                          className={`w-full px-4 py-3 rounded-xl border-2 focus:outline-none transition-all ${this.state.usernameAvailable === true
                            ? "border-green-400 bg-green-50"
                            : this.state.usernameAvailable === false
                              ? "border-red-400 bg-red-50"
                              : "border-gray-200 focus:border-amber-400"
                            }`}
                          placeholder="username"
                          value={this.state.username}
                          onChange={(e) => {
                            const val = e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, "");
                            this.setState({ username: val });
                            this.checkUsernameAvailability(val);
                          }}
                        />
                        {this.state.checkingUsername && (
                          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                            <div className="animate-spin w-5 h-5 border-2 border-amber-500 border-t-transparent rounded-full"></div>
                          </div>
                        )}
                        {!this.state.checkingUsername && this.state.usernameAvailable === true && (
                          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                            <i className="bx bx-check-circle text-green-500 text-xl"></i>
                          </div>
                        )}
                        {!this.state.checkingUsername && this.state.usernameAvailable === false && (
                          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                            <i className="bx bx-x-circle text-red-500 text-xl"></i>
                          </div>
                        )}
                      </div>
                      {this.state.usernameAvailable === false && this.state.usernameRecommendations.length > 0 && (
                        <div className="mt-2">
                          <p className="text-xs text-gray-600 mb-1">Saran username:</p>
                          <div className="flex flex-wrap gap-1">
                            {this.state.usernameRecommendations.map((rec, idx) => (
                              <button
                                key={idx}
                                type="button"
                                className="px-2 py-1 bg-amber-100 text-amber-700 rounded text-xs hover:bg-amber-200"
                                onClick={() => {
                                  this.setState({ username: rec });
                                  this.checkUsernameAvailability(rec);
                                }}
                              >
                                {rec}
                              </button>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Email */}
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Email <span className="text-red-500">*</span>
                        {this.state.userStatus === "Active" && (
                          <span className="ml-2 text-xs text-gray-500 font-normal">(tidak dapat diubah)</span>
                        )}
                      </label>
                      <div className="relative">
                        <input
                          type="email"
                          className={`w-full px-4 py-3 rounded-xl border-2 focus:outline-none transition-all ${this.state.userStatus === "Active"
                            ? "border-gray-200 bg-gray-100 cursor-not-allowed"
                            : this.state.emailAvailable === true
                              ? "border-green-400 bg-green-50"
                              : this.state.emailAvailable === false
                                ? "border-red-400 bg-red-50"
                                : "border-gray-200 focus:border-amber-400"
                            }`}
                          placeholder="email@domain.com"
                          value={this.state.email}
                          disabled={this.state.userStatus === "Active"}
                          onChange={(e) => {
                            if (this.state.userStatus !== "Active") {
                              const val = e.target.value.toLowerCase();
                              this.setState({ email: val });
                              this.checkEmailAvailability(val);
                            }
                          }}
                        />
                        {this.state.userStatus === "Active" && (
                          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                            <i className="bx bx-lock text-gray-400 text-xl"></i>
                          </div>
                        )}
                        {this.state.userStatus !== "Active" && this.state.checkingEmail && (
                          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                            <div className="animate-spin w-5 h-5 border-2 border-amber-500 border-t-transparent rounded-full"></div>
                          </div>
                        )}
                        {this.state.userStatus !== "Active" && !this.state.checkingEmail && this.state.emailAvailable === true && (
                          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                            <i className="bx bx-check-circle text-green-500 text-xl"></i>
                          </div>
                        )}
                        {this.state.userStatus !== "Active" && !this.state.checkingEmail && this.state.emailAvailable === false && (
                          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                            <i className="bx bx-x-circle text-red-500 text-xl"></i>
                          </div>
                        )}
                      </div>
                      {this.state.emailAvailable === false && this.state.emailMessage && (
                        <p className="text-red-500 text-xs mt-1">{this.state.emailMessage}</p>
                      )}
                    </div>

                    {/* Password */}
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Password {this.state.userStatus === "Pending" && <span className="text-red-500">*</span>}
                        {this.state.userStatus === "Active" && (
                          <span className="ml-2 text-xs text-gray-500 font-normal">(kosongkan jika tidak diubah)</span>
                        )}
                      </label>
                      <div className="relative">
                        <input
                          type={this.state.showPassword ? "text" : "password"}
                          className="w-full px-4 py-3 pr-12 rounded-xl border-2 border-gray-200 focus:border-amber-400 focus:outline-none transition-all"
                          placeholder={this.state.userStatus === "Active" ? "Kosongkan jika tidak diubah" : "Minimal 8 karakter"}
                          value={this.state.password}
                          onChange={(e) => {
                            this.setState({ password: e.target.value });
                            this.checkPasswordStrength(e.target.value);
                          }}
                        />
                        <button
                          type="button"
                          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                          onClick={this.togglePasswordVisibility}
                        >
                          <i className={`bx ${this.state.showPassword ? "bx-hide" : "bx-show"} text-xl`}></i>
                        </button>
                      </div>
                      {this.state.password && (
                        <div className="mt-2">
                          <div className="flex items-center gap-2">
                            <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
                              <div
                                className={`h-full transition-all ${this.state.passwordStrength === "weak"
                                  ? "w-1/3 bg-red-500"
                                  : this.state.passwordStrength === "medium"
                                    ? "w-2/3 bg-yellow-500"
                                    : "w-full bg-green-500"
                                  }`}
                              ></div>
                            </div>
                            <span
                              className={`text-xs font-medium ${this.state.passwordStrength === "weak"
                                ? "text-red-500"
                                : this.state.passwordStrength === "medium"
                                  ? "text-yellow-600"
                                  : "text-green-500"
                                }`}
                            >
                              {this.state.passwordStrengthText}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* No Telepon */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        No. Handphone <span className="text-xs text-gray-500 font-normal">(Opsional)</span>
                      </label>
                      <input
                        type="tel"
                        className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-amber-400 focus:outline-none transition-all"
                        placeholder="08xxxxxxxxxx"
                        value={this.state.no_telepon}
                        onChange={this.no_telepon}
                      />
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                  <button
                    type="button"
                    className="px-6 py-2.5 rounded-xl border-2 border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition-all"
                    onClick={this.hideModalEdit}
                  >
                    Batal
                  </button>
                  <button
                    type="submit"
                    disabled={this.state.simpleLoading || this.state.checkingUsername || this.state.checkingEmail || this.state.checkingNik || this.state.usernameAvailable === false || (this.state.userStatus !== "Active" && this.state.emailAvailable === false) || this.state.nikAvailable === false}
                    className="px-6 py-2.5 rounded-xl text-white font-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                    style={{
                      background: this.state.simpleLoading
                        ? "#9ca3af"
                        : "linear-gradient(135deg, #0891b2 0%, #06b6d4 100%)",
                    }}
                  >
                    {this.state.simpleLoading ? (
                      <span className="flex items-center">
                        <div className="animate-spin w-4 h-4 border-2 border-white border-t-transparent rounded-full mr-2"></div>
                        Menyimpan...
                      </span>
                    ) : (
                      <span className="flex items-center">
                        <i className="bx bx-save mr-2"></i>
                        Simpan Perubahan
                      </span>
                    )}
                  </button>
                </div>
              </form>
            </Modal.Body>
          )}
        </Modal>

        {/* modal detail */}
        <Modal
          size="lg"
          show={this.state.modal_detail}
          onHide={this.hideModalDetail}
        >
          {this.state.loading_detail ? (
            <UserDetailSkeleton />
          ) : (
            <Modal.Body className="">
              <div className="flex flex-col w-full">
                <div
                  className={`w-full rounded-lg bg-1 mb-10`}
                  style={{ height: "10rem" }}
                >
                  <div
                    className="overflow-hidden rounded-lg"
                    style={{ height: "10rem" }}
                  >
                    <img
                      className=""
                      src={
                        this.state.data_detail.foto_sampul
                          ? `https://static.schoolmedia.id/public/assets/socmed/LA/cover/${this.state.data_detail.foto_sampul}`
                          : `${conf.uri_frontend}assets/img/cover-unavailable.svg`
                      }
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div
                    className="flex flex-row px-4 pb-4 rounded-lg items-center w-full bg-transparent-grad relative"
                    style={{ bottom: "10rem", paddingTop: "6rem" }}
                  >
                    <img
                      className="rounded-full border-4 border-white shadow-xl"
                      style={{
                        width: "6rem",
                        height: "6rem",
                        objectFit: "cover",
                      }}
                      src={
                        this.state.data_detail.foto_profil
                          ? `${conf.uri_s3}/00-universal/${this.state.data_detail.website}/LA/${this.state.data_detail.foto_profil}`
                          : `${conf.uri_frontend}assets/img/profile-unavailable.png`
                      }
                    />
                    <h1 className="text-xl font-bold text-gray-800 ml-2">
                      {this.state.data_detail.nama
                        ? this.state.data_detail.nama
                        : "-"}
                    </h1>
                  </div>
                </div>
              </div>
              <Tabs
                defaultActiveKey="detail1"
                id="uncontrolled-tab-example"
                className="mt-4"
              >
                <Tab eventKey="detail1" title="Detail 1">
                  <div className="show-grid flex">
                    <div className="sm:w-full w-1/2">
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Token
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.token
                            ? this.state.data_detail.token
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          No Pendaftaran
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.kode_pendaftaran
                            ? this.state.data_detail.kode_pendaftaran
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Jenis Kelamin
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.jenis_kelamin != null
                            ? this.state.data_detail.jenis_kelamin != 1
                              ? "Perempuan"
                              : "Laki - laki"
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Tempat Lahir
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.tempat_lahir
                            ? this.state.data_detail.tempat_lahir
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Tanggal Lahir
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.tanggal_lahir
                            ? this.state.data_detail.tanggal_lahir
                            : "-"}
                        </p>
                      </div>
                    </div>
                    <div className="sm:w-full w-1/2">
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Agama
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.agama
                            ? this.state.data_detail.agama
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          No. Handphone
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.no_handphone
                            ? this.state.data_detail.no_handphone
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Golongan Darah
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.golongan_darah
                            ? this.state.data_detail.golongan_darah
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Pendidikan Terakhir
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.pendidikan_terakhir
                            ? this.state.data_detail.pendidikan_terakhir
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Motto
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.motto
                            ? this.state.data_detail.motto
                            : "-"}
                        </p>
                      </div>
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="detail2" title="Detail 2">
                  <div className="show-grid flex">
                    <div className="sm:w-full w-1/3">
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          No. KK
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.kk
                            ? this.state.data_detail.kk
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          No. NIK
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.nik
                            ? this.state.data_detail.nik
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          No. NPWP
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.npwp
                            ? this.state.data_detail.npwp
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          No. Paspor
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.paspor
                            ? this.state.data_detail.paspor
                            : "-"}
                        </p>
                      </div>
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-700 block text-xs">
                          Negara
                        </label>
                        <p className="mb-2 ml-2 text-gray-900 block text-base">
                          {this.state.data_detail.negara
                            ? this.state.data_detail.negara
                            : "-"}
                        </p>
                      </div>
                    </div>
                    <div className="sm:w-full w-1/3">
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-900 block text-sm">
                          Alamat Tinggal
                        </label>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Provinsi
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.provinsi_tinggal
                              ? this.state.data_detail.provinsi_tinggal
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Kabupaten / Kota
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.kabupaten_tinggal
                              ? this.state.data_detail.kabupaten_tinggal
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Kecamatan
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.kecamatan_tinggal
                              ? this.state.data_detail.kecamatan_tinggal
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Desa
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.desa_tinggal
                              ? this.state.data_detail.desa_tinggal
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Kode Pos
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.kode_pos__tinggal
                              ? this.state.data_detail.kode_pos__tinggal
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            RW / RT
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.rw_tinggal
                              ? this.state.data_detail.rw_tinggal
                              : "-"}{" "}
                            /
                            {this.state.data_detail.rt_tinggal
                              ? ` ${this.state.data_detail.rt_tinggal}`
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Alamat
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.alamat_tinggal
                              ? this.state.data_detail.alamat_tinggal
                              : "-"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="sm:w-full w-1/3">
                      <div className="w-full mt-3">
                        <label className="mb-1 ml-2 text-gray-900 block text-sm">
                          Alamat Domisili
                        </label>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Provinsi
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.provinsi_domisili
                              ? this.state.data_detail.provinsi_domisili
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Kabupaten / Kota
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.kabupaten_domisili
                              ? this.state.data_detail.kabupaten_domisili
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Kecamatan
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.kecamatan_domisili
                              ? this.state.data_detail.kecamatan_domisili
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Desa
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.desa_domisili
                              ? this.state.data_detail.desa_domisili
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Kode Pos
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.kode_pos__domisili
                              ? this.state.data_detail.kode_pos__domisili
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            RW / RT
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.rw_domisili
                              ? this.state.data_detail.rw_domisili
                              : "-"}{" "}
                            /
                            {this.state.data_detail.rt_domisili
                              ? ` ${this.state.data_detail.rt_domisili}`
                              : "-"}
                          </p>
                        </div>
                        <div className="pl-2">
                          <label className="mb-1 ml-2 text-gray-700 block text-xs">
                            Alamat
                          </label>
                          <p className="mb-2 ml-2 text-gray-900 block text-base">
                            {this.state.data_detail.alamat_domisili
                              ? this.state.data_detail.alamat_domisili
                              : "-"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab>
              </Tabs>
              {/* <div className="show-grid flex mt-4 border-t">
                <div className="sm:w-full w-1/2 px-2">
                  <p className="my-2 ml-2 text-gray-900 block text-sm font-bold">
                    Foto KTP
                  </p>
                  <img
                    className="w-full"
                    style={{
                      height: "300px",
                      objectFit: "none",
                      objectPosition: "center",
                    }}
                    src={
                      this.state.data_detail.foto_ktp
                        ? `https://static.schoolmedia.id/public/assets/socmed/LA/ktp/${this.state.data_detail.foto_ktp}`
                        : `${conf.uri_frontend}assets/img/img-unavailable.png`
                    }
                  />
                </div>
                <div className="sm:w-full w-1/2 px-2">
                  <p className="my-2 ml-2 text-gray-900 block text-sm font-bold">
                    Foto KTP & Wajah
                  </p>
                  <img
                    className="w-full"
                    style={{
                      height: "300px",
                      objectFit: "none",
                      objectPosition: "center",
                    }}
                    src={
                      this.state.data_detail.foto_ktp_dan_wajah
                        ? `https://static.schoolmedia.id/public/assets/socmed/LA/ktp-face/${this.state.data_detail.foto_ktp_dan_wajah}`
                        : `${conf.uri_frontend}assets/img/img-unavailable.png`
                    }
                  />
                </div>
              </div>
              <div className="w-full">
                <div className="rounded-lg w-1/2 mx-auto">
                  <p className="my-2 ml-2 text-gray-900 block text-sm font-bold">
                    Foto Doc. Pendukung
                  </p>
                  <img
                    className="w-full"
                    style={{
                      height: "300px",
                      objectFit: "none",
                      objectPosition: "center",
                    }}
                    src={
                      this.state.data_detail.foto_doc_pendukung
                        ? `https://static.schoolmedia.id/public/assets/socmed/LA/img-support/${this.state.data_detail.foto_doc_pendukung}`
                        : `${conf.uri_frontend}assets/img/img-unavailable.png`
                    }
                  />
                </div>
              </div> */}
            </Modal.Body>
          )}
          <Modal.Footer>
            <button
              className="btn-default mx-1 px-4 py-2 justify-center font-medium rounded-full text-gray-800 items-center text-sm"
              onClick={this.hideModalDetail}
            >
              Tutup
            </button>
          </Modal.Footer>
        </Modal>

        {/* Cetak Modal */}
        <Modal
          size="lg"
          show={this.state.modal_cetak}
          onHide={this.hideModalCetak}
        >
          <Modal.Header>Cetak User Lainnya</Modal.Header>
          <Modal.Body>
            <div className="flex justify-between items-center w-full px-2 py-2">
              <div className="w-1/2 flex items-center justify-start">
                <input
                  type="search"
                  className="w-2/3 pl-4 pr-1 py-1 rounded-full  border border-gray-500 focus:outline-none focus:shadow-outline text-gray-800 text-sm "
                  placeholder="Cari nama"
                  id="search"
                  onChange={(event) => {
                    this.setState(
                      {
                        queryToken: `&search=${event.target.value}
                                  &paginate=${this.state.mode_show_token}`,
                        searchToken: event.target.value,
                      },
                      function () {
                        this.dtt.loading();
                        this.dtt.fetchEntities(this.state.queryToken);
                      }
                    );
                  }}
                />
                <div className="ml-2 w-1/3 pl-3 pr-3 py-1 rounded-full flex justify-between items-center  border border-gray-500 focus:outline-none focus:shadow-outline  text-sm ">
                  <span className="text-sm text-gray-800">Pilih semua</span>
                  <input
                    type="checkbox"
                    className="select-all"
                    onChange={this.pilihSemua.bind(this)}
                  />
                </div>
              </div>
              <div className="w-1/2 text-right flex items-center">
                <div className="w-full ml-1 flex flex-wrap text-right items-center justify-end">
                  <div className="mr-0 flex text-right items-center">
                    <span className="text-sm  ml-auto text-gray-800 px-1 mb-2">
                      Tampilkan :{" "}
                    </span>
                    <button
                      onClick={this.showModeToken.bind(this, 10)}
                      className={`${this.state.mode_show_token == 10
                        ? `btn-schoolmedia`
                        : `bg-gray-400`
                        } px-1 flex items-center rounded-full text-white py-1 text-xs mr-1`}
                    >
                      10
                    </button>
                    <button
                      onClick={this.showModeToken.bind(this, 50)}
                      className={`${this.state.mode_show_token == 50
                        ? `btn-schoolmedia`
                        : `bg-gray-400`
                        } px-1 flex items-center rounded-full text-white py-1 text-xs mr-1`}
                    >
                      50
                    </button>
                    <button
                      onClick={this.showModeToken.bind(this, 100)}
                      className={`${this.state.mode_show_token == 100
                        ? `btn-schoolmedia`
                        : `bg-gray-400`
                        } px-1 flex items-center rounded-full text-white py-1 text-xs mr-1`}
                    >
                      100
                    </button>
                    <button
                      onClick={this.showModeToken.bind(this, 200)}
                      className={`${this.state.mode_show_token == 200
                        ? `btn-schoolmedia`
                        : `bg-gray-400`
                        } px-1 flex items-center rounded-full text-white py-1 text-xs mr-1`}
                    >
                      200
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div id="cetakToken">
              {this.showTableToken()}
              {this.state.loading_saveprint ? (
                <button
                  className="btn-schoolmedia px-4 flex items-center rounded-full text-white mt-2 py-2 text-sm"
                  disabled={this.state.loading_saveprint == true ? true : false}
                >
                  <UserButtonLoading />
                </button>
              ) : (
                <input
                  type="button"
                  onClick={this.printToken.bind(this)}
                  className="btn-schoolmedia px-4 flex items-center rounded-full text-white mt-2 py-2 text-sm"
                  value="Simpan"
                />
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn-default mx-1 px-4 py-2 justify-center font-medium rounded-full text-gray-800 items-center text-sm"
              onClick={this.hideModalCetak}
            >
              Tutup
            </button>
          </Modal.Footer>
        </Modal>

        {/* Upload / Import - Premium Excel Import Wizard */}
        <ExcelImportWizard
          show={this.state.modal_import}
          onClose={() => {
            this.hideModalImport();
            // Refresh data after closing import wizard
            this.dt.fetchEntities(
              `&paginate=${this.state.mode_show}&query=${this.state.query}`
            );
            this.showCount();
          }}
          title="Upload Data User Lainnya"
          type="LA"
          institusiId={this.state.institusi_id_select}
        />

        {/* Preview Import */}
        <Modal
          size="lg"
          show={this.state.modal_preview_import}
          onHide={this.hideModalPrevImport}
        >
          <Modal.Header>Preview Import</Modal.Header>
          <Modal.Body>
            <form onSubmit={this.simpanImport}>
              <div className="table-responsive">
                <table className="table table-bordered font-thin text-sm">
                  <thead className="text-center">
                    <th>KODE PENDAFTARAN</th>
                    <th>NAMA</th>
                    <th>JENIS KELAMIN</th>
                    <th>TANGGAL LAHIR</th>
                    <th>NO. HP</th>
                    <th>USERNAME</th>
                    <th>EMAIL</th>
                    <th>PASSWORD</th>
                    <th>NAMA FILE FOTO PROFIL</th>
                  </thead>
                  <tbody>
                    {this.state.data_preview.map((person, index) => (
                      <tr className={person.duplicated ? 'table-danger' : ''} key={index}>
                        <td>
                          <div className="text-sm">
                            {person.kode_pendaftaran}
                          </div>
                        </td>
                        <td>
                          <div className="text-sm">{person.nama}</div>
                        </td>
                        <td>
                          <div className="text-sm">
                            {
                              this.state.jenis_kelamin_text[
                              person.jenis_kelamin
                              ]
                            }
                          </div>
                        </td>
                        <td>
                          <div className="text-sm">{person.tanggal_lahir}</div>
                        </td>
                        <td>
                          <div className="text-sm">{person.no_handphone}</div>
                        </td>
                        <td>
                          {" "}
                          <div className="text-sm">{person.username}</div>
                        </td>
                        <td>
                          {" "}
                          <div className="text-sm">{person.email}</div>
                        </td>
                        <td>
                          {" "}
                          <div className="text-sm">{person.password}</div>
                        </td>
                        <td>
                          <div className="text-sm">{person.foto_profil}</div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <input
                type="submit"
                className={
                  this.state.simpleLoading
                    ? "btn-disabled px-4 flex items-center rounded-full py-2 mt-2 text-sm"
                    : "btn-schoolmedia px-4 flex items-center rounded-full text-white py-2 mt-2 text-sm"
                }
                value={this.state.simpleLoading ? "Tunggu..." : "Simpan"}
                disabled={this.state.simpleLoading ? true : false}
              />
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn-default mx-1 px-4 py-2 justify-center font-medium rounded-full text-gray-800 items-center text-sm"
              onClick={this.hideModalPrevImport}
            >
              Tutup
            </button>
          </Modal.Footer>
        </Modal>

        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm mx-auto p-6 mt-4 sm-container">
          {this.state.institusi_id_select != "" ? (
            <>
              <div className="flex flex-col lg:flex-row lg:items-center gap-4 pb-4">
                {/* Search Input */}
                <div className="relative flex-1">
                  <span className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-gray-400">
                    <i className="bx bx-search text-xl"></i>
                  </span>
                  <input
                    type="search"
                    id="search"
                    className="w-full pl-10 pr-4 py-2 rounded-xl border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 bg-gray-50/50 text-gray-800 text-sm focus:bg-white focus:outline-none"
                    placeholder="Cari kode pendaftaran, nama, username, token..."
                    onChange={this.searchText}
                  />
                </div>

                {/* Filter and Status Controls */}
                <div className="flex flex-wrap items-center gap-3">
                  {/* Status Dropdown */}
                  <div className="w-52" style={{ minWidth: "180px" }}>
                    <Select
                      styles={selectStyles}
                      className="text-sm"
                      placeholder="Pilih Status"
                      isClearable
                      isDisabled={this.state.disabledFilter}
                      defaultValue={
                        this.state.selectStatus != ""
                          ? {
                            value: this.state.selectStatus,
                            label: this.state.selectStatus,
                          }
                          : null
                      }
                      options={[
                        { value: "Active", label: "Active" },
                        { value: "Pending", label: "Pending" },
                      ]}
                      onChange={(e) => {
                        this.changeStatus(e);
                      }}
                    />
                  </div>

                  {/* Total Data Count Badge */}
                  <div className="flex items-center gap-1.5 px-3 py-2 bg-gray-50 border border-gray-150 rounded-xl text-xs font-semibold text-gray-600">
                    <span>Total data:</span>
                    <span className="text-gray-900 bg-gray-200/50 px-2 py-0.5 rounded-md font-bold">
                      {this.state.totalUser != "" ? (
                        this.state.totalUser
                      ) : (
                        <i className="bx bx-loader-alt bx-spin"></i>
                      )}
                    </span>
                  </div>
                </div>

                {/* Show limit page buttons */}
                <div className="flex items-center gap-2 lg:ml-auto border-t lg:border-t-0 pt-3 lg:pt-0">
                  <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider mr-1">
                    Tampilkan:
                  </span>
                  <div className="inline-flex rounded-xl p-1 bg-gray-100/80">
                    {[10, 50, 100, 200].map((limit) => (
                      <button
                        key={limit}
                        onClick={this.showMode.bind(this, limit)}
                        className={`px-3 py-1 rounded-lg text-xs font-semibold transition-all duration-200 ${
                          this.state.mode_show === limit
                            ? "bg-white text-blue-600 shadow-sm font-bold"
                            : "text-gray-600 hover:text-gray-900"
                        }`}
                      >
                        {this.state.loading_showmode === limit ? (
                          <div className="w-3 h-3 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                        ) : (
                          limit
                        )}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="w-full flex justify-between gap-4 py-2">
              <div className="w-1/2 flex gap-4">
                <Skeleton width={180} height={38} className="rounded-xl" />
                <Skeleton width={120} height={38} className="rounded-xl" />
              </div>
              <div className="w-1/2 flex justify-end gap-4">
                <Skeleton width={180} height={38} className="rounded-xl" />
              </div>
            </div>
          )}

          <div className="mt-4 overflow-hidden border border-gray-100 rounded-2xl bg-gray-50/20 px-2 py-1">
            <DataTable
              ref={(dt) => {
                this.dt = dt;
              }}
              action={{
                jenis_kelamin: (col, data) => {
                  var jekel = "";
                  if (col.jenis_kelamin == 1) {
                    jekel = "Laki - Laki";
                  }

                  if (col.jenis_kelamin == 0) {
                    jekel = "Perempuan";
                  }

                  if (col.jenis_kelamin == null) {
                    jekel = "Belum diketahui";
                  }
                  return <p className="text-sm">{jekel}</p>;
                },

                created_at: (col, data) => {
                  if (col.created_at !== null) {
                    var date = "";
                    var month = "";
                    var year = "";
                    date = col.created_at.substr(8, 2);
                    month = col.created_at.substr(5, 2);
                    year = col.created_at.substr(0, 4);

                    return (
                      <p className="text-sm">
                        {date + "-" + month + "-" + year}
                      </p>
                    );
                  } else {
                    return <p className="text-sm">Tidak Diketahui</p>;
                  }
                },

                status: (col, data) => {
                  var statusUsr = "";
                  var tooltip = "";
                  var warna = "";
                  var ikon = "";
                  var width = "";

                  if (col.status == "Active") {
                    statusUsr = "Aktif";
                    tooltip = "User sudah teraktivasi";
                    warna = "bg-green-600";
                    ikon = "bx-check";
                    width = "w-16";
                  } else if (col.status == "Non-Active") {
                    statusUsr = "Non-Aktif";
                    tooltip = "User telah dinon-aktifkan";
                    warna = "bg-red-600";
                    ikon = "bx-x";
                    width = "w-auto";
                  } else {
                    statusUsr = "Pending";
                    tooltip =
                      "User belum aktivasi di SSO dan klik link konfirmasi di email";
                    warna = "bg-gray-600";
                    ikon = "bx-error";
                    width = "w-20";
                  }
                  return (
                    <OverlayTrigger overlay={<Tooltip>{tooltip}</Tooltip>}>
                      <div
                        className={`py-1 ${width} px-1 ${warna} text-white text-xs rounded-full flex cursor`}
                      >
                        <i
                          className={`bx ${ikon} text-white font-bold text-sm mx-1`}
                        ></i>
                        {statusUsr}
                      </div>
                    </OverlayTrigger>
                  );
                },

                token: (col, data) => {
                  var button = "";
                  if (col.token === null) {
                    button = (
                      <div>
                        <div className="text-sm" id={"token" + data.id}></div>
                        <button
                          onClick={this.generate_token.bind(this, data.id)}
                          id={"myButton" + data.id}
                          className="font-medium btn-default text-gray-700 px-4 py-2 mr-1 rounded-full text-sm"
                          disabled={
                            this.state.loading_token === data.id ? true : false
                          }
                        >
                          {this.state.loading_token === data.id ? (
                            <UserButtonLoading color="text-gray-800" />
                          ) : (
                            "Token"
                          )}
                        </button>
                      </div>
                    );
                  } else {
                    button = <div className="text-sm">{col.token}</div>;
                  }
                  return button;
                },
                emaila: (col, data) => {
                  if (data?.email == null || data?.email == "") {
                    var value = "-";
                  } else {
                    var value = data.email;
                  }
                  return (
                    <>
                      <small className="text-small">{value}</small>
                    </>
                  );
                },
                usernamea: (col, data) => {
                  if (data?.username == null || data?.username == "") {
                    var value = "-";
                  } else {
                    var value = data.username;
                  }
                  return (
                    <>
                      <small className="text-small">{value}</small>
                    </>
                  );
                },

                aksi: (col, data) => {
                  return (
                    <div className="text-gray-700 px-4 py-1 flex items-center">
                      <button
                        onClick={this.showModalDetail.bind(this, data.id)}
                        className="btn-blue text-lg text-white py-1 px-2 rounded-full font-medium mr-1"
                      >
                        <i className="bx bxs-user-detail"></i>
                      </button>
                      <button
                        onClick={this.showModalEdit.bind(this, data.id)}
                        className="btn-yellow text-lg text-white py-1 px-2 rounded-full font-medium mr-1"
                      >
                        <i className="bx bxs-edit-alt"></i>
                      </button>
                      <button
                        onClick={() => this.delete(data.id, data.nama)}
                        className={`${this.state.loading_delete === true
                          ? `btn-gray`
                          : `btn-red`
                          } text-lg text-white py-1 px-2 rounded-full font-medium`}
                        disabled={
                          this.state.loading_delete === true ? true : false
                        }
                      >
                        <i className="bx bx-trash"></i>
                      </button>
                      {this.state.loading_check == false ? (
                        <input
                          type="checkbox"
                          name="check_data[]"
                          id={data.id}
                          value={data.id}
                          onChange={this.selectOne}
                          className="select-checkbox ml-2"
                          defaultChecked={this.state.checkAll}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  );
                },
              }}
              url={this.state.url_table + this.state.institusi_id_select}
              columns={[
                {
                  index: "no_index",
                  label: "No",
                },
                {
                  index: "kode_pendaftaran",
                  label: "KODE PENDAFTARAN",
                },
                {
                  index: "nama",
                  label: "NAMA",
                },
                {
                  index: "usernamea",
                  label: "USERNAME",
                },
                {
                  index: "emaila",
                  label: "EMAIL",
                },
                {
                  index: "jenis_kelamin",
                  label: "JENIS KELAMIN",
                },
                {
                  index: "no_handphone",
                  label: "NO HP",
                },
                {
                  index: "tanggal_lahir",
                  label: "TANGGAL LAHIR",
                },
                {
                  index: "created_at",
                  label: "TANGGAL PENDAFTARAN",
                  sort: "desc",
                },
                {
                  index: "status",
                  label: "STATUS",
                },
                {
                  index: "token",
                  label: "TOKEN",
                },
                {
                  index: "aksi",
                  label: "AKSI",
                },
              ]}
            />
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm mx-auto p-4 mt-4 sm-container">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 px-2">
            <div className="flex items-center gap-2 text-gray-500">
              <i className="bx bx-checkbox-checked text-2xl text-blue-500"></i>
              <span className="text-sm font-medium">Tandai beberapa staf di tabel untuk melakukan aksi massal</span>
            </div>
            
            <div className="flex flex-wrap items-center gap-2 sm:justify-end">
              {this.state.checkAll === false ? (
                <button
                  className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-gray-700 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 transition-all duration-200 shadow-sm"
                  onClick={this.checkAll}
                >
                  <i className="bx bx-check-square text-lg"></i>
                  <span>Pilih Semua</span>
                </button>
              ) : (
                <button
                  className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-blue-600 bg-blue-50 border border-blue-150 rounded-xl hover:bg-blue-100 transition-all duration-200 shadow-sm"
                  onClick={this.unCheckAll}
                >
                  <i className="bx bx-x-square text-lg"></i>
                  <span>Batal Pilih</span>
                </button>
              )}

              <button
                onClick={this.deleteMulti}
                className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-rose-600 bg-rose-50 border border-rose-100 rounded-xl hover:bg-rose-100 hover:text-rose-700 transition-all duration-200 shadow-sm"
                disabled={this.state.loading_delete}
              >
                {this.state.loading_delete ? (
                  <UserButtonLoading color="text-rose-600" />
                ) : (
                  <>
                    <i className="bx bx-trash text-lg"></i>
                    <span>Hapus</span>
                  </>
                )}
              </button>

              <button
                onClick={this.sendMailActivation}
                className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-blue-600 bg-blue-50 border border-blue-100 rounded-xl hover:bg-blue-100 hover:text-blue-700 transition-all duration-200 shadow-sm"
                disabled={this.state.loading_delete}
              >
                {this.state.loading_mail ? (
                  <UserButtonLoading color="text-blue-600" />
                ) : (
                  <>
                    <i className="bx bx-envelope text-lg"></i>
                    <span>Send Email</span>
                  </>
                )}
              </button>

              <button
                onClick={this.sendWAActivation}
                className="flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-emerald-600 bg-emerald-50 border border-emerald-100 rounded-xl hover:bg-emerald-100 hover:text-emerald-700 transition-all duration-200 shadow-sm"
                disabled={this.state.loading_delete}
              >
                {this.state.loading_mail ? (
                  <UserButtonLoading color="text-emerald-600" />
                ) : (
                  <>
                    <i className="bx bxl-whatsapp text-lg"></i>
                    <span>Send WA</span>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}